import { Autocomplete, Avatar, Backdrop, Badge, Box, Button, Card, CardHeader, Checkbox, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, Grid, IconButton, LinearProgress, List, ListItem, ListItemIcon, ListItemText, Menu, MenuItem, Skeleton, Stack, Switch, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, TextField, Tooltip, Typography } from "@material-ui/core";
import Page from '../../components/Page';
import { capitalCase, sentenceCase } from "change-case";
import moreVerticalFill from '@iconify/icons-eva/more-vertical-fill';
import trash2Outline from '@iconify/icons-eva/trash-2-outline';
import lockOpenFill from '@iconify/icons-ph/lock-open-fill';
import editFill from '@iconify/icons-eva/edit-fill';
import plusFill from '@iconify/icons-eva/plus-fill';
//materail
import * as Yup from 'yup';
import { Form, FormikProvider, useFormik } from 'formik';
import { alpha, makeStyles, experimentalStyled as styled } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import HeaderBreadcrumbs from "src/components/HeaderBreadcrumbs";
import Label from "src/components/Label";
import { useLocation, useNavigate, useParams } from "react-router";
import filePdfIcon from '@iconify/icons-mdi/file-pdf';

import ViewRequest from "src/components/_dashboard/official-request/ViewRequest";
import { forwardRef, useEffect, useRef, useState } from "react";
import PublicMsgBoard from "src/components/_dashboard/official-request/PublicMsgBoard";
import RequestTabUpdates from 'src/components/_dashboard/user/account/RequestTabUpdates'
import PublicMessageBoard from 'src/components/_dashboard/user/profile/PublicMessageBoard.js'
import RequestUpdates from "src/components/_dashboard/official-request/RequestUpdates";
import PaymentRequest from "src/components/_dashboard/official-request/PaymentRequest";
import { AddCircle, BlockOutlined, Delete, KeyboardBackspaceOutlined, Print, LocationOn, Add, Remove, CenterFocusStrong, UploadFile } from "@material-ui/icons";
import Modal from "src/components/_dashboard/blog/ProjectModel";
import Icon from "@iconify/react";
import Scrollbar from "src/components/Scrollbar";
import axios from "axios";
import { REST_API, REST_API_END_POINT, SEND_EMAIL, UNITS } from "src/constants/Defaultvalues";
import moment from "moment";
import { PATH_DASHBOARD } from "src/routes/paths";
import { useSnackbar } from "notistack";
import { LoadingButton, MobileDatePicker } from "@material-ui/lab";
import { useCallback } from "react";
import { UploadAvatar, UploadMultiFile } from "src/components/upload";
import AddClients from "src/components/_dashboard/official-request/AddClients";
import AddProposal from "src/components/_dashboard/official-request/AddProposal";
import ConfirmationPopup from "src/components/_dashboard/official-request/ConfirmationPopup";
import ReactToPrint from 'react-to-print'
import { storage } from '../../firebase/firebase'
import { getDownloadURL, ref as imageref, uploadBytesResumable } from 'firebase/storage';
import { Link } from "react-router-dom";
import { empty } from "src/Helpers/Common";
import Locations from "src/components/_dashboard/official-request/Locations";
import Workflow from "src/components/_dashboard/general-analytics/RfqForm";
import { AccountNotifications } from '../../components/_dashboard/user/account'
import { set } from "lodash";
import Proposals from "src/components/_dashboard/official-request/Proposals";
import useCompanyProfile from "src/hooks/useCompanyProfile";
import LoadingScreen from "src/components/LoadingScreen";
import { MButton } from "src/components/@material-extend";
import { DialogAnimate } from "src/components/animate";
import AVALARALOGO from 'src/assets/Avalara_Logo.png';

const RowResultStyle = styled(TableRow)(({ theme }) => ({
  '& td': {
    paddingTop: theme.spacing(1),
    paddingBottom: theme.spacing(1)
  }
}));

const getStatusColorAndLabel = (status) => {
  switch (status) {
    case 0:
      return { color: 'error', label: 'Status: Removed' };
    case 1:
      return { color: 'warning', label: 'Status: Draft' };
    case 2:
      return { color: 'info', label: 'Status: Open' };
    case 3:
      return { color: 'primary', label: 'Status: Evaluating' };
    case 4:
      return { color: 'success', label: 'Status: Accepted' };
    case 5:
      return { color: 'warning', label: 'Status: Closed' };
    case 6:
      return { color: 'error', label: 'Status: Rejected' };
    default:
      return { color: 'default', label: 'Status: Open' };
  }
};

const markupTypes = [
  { id: 1, name: 'Wholesale Markup' },
  { id: 2, name: 'Retail Markup' }
]

const useStyles = makeStyles((theme) => ({
  attachmentBox: {
      cursor: 'pointer',
      display: 'flex',
      borderRadius: '6px',
      backgroundColor: '#172e34',
      padding: theme.spacing(1),
      margin: theme.spacing(1, 0),
      justifyContent: 'center',
      alignItems: 'center',
      position: 'relative', 
      height: '100px', 
      overflow: 'hidden'
  },
  attachmentIcon: {
      marginRight: theme.spacing(1),
  },
  delete:{
      m:2,
      display:'flex',
      justifyContent:'flex-end' 
    },
  checkbox: {
      position: 'absolute',
      top: theme.spacing(1), 
      right: theme.spacing(1), 
  },
  checkboxContainer: {
      position: 'absolute',
      top: theme.spacing(1),
      right: theme.spacing(1),
  },
  dialogContent: {
      padding: theme.spacing(3),
      maxWidth: 768,
      margin: 'auto',
      display: 'flex',
      flexDirection:'column',
      justifyContent: 'center',
      alignItems: 'center',
  },
  gridContainer: {
      height: 'auto',
  },
}));

export default function ViewofficialRequest({popupOn,projectId,isEditPurchaseOrder,setIsEditPurchaseOrder,closeView,handleDataChange}) {
  const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
  const theme = useTheme()
  const { id:ids } = useParams()

  console.log("purchaseOrderProjectId==1",useParams());
  const id =popupOn ? projectId : ids
  const edit =popupOn ? isEditPurchaseOrder:useLocation().state
  let editState=popupOn ? isEditPurchaseOrder :useLocation().state || false
  console.log("purchaseOrder=========isEditPurchaseOrder",isEditPurchaseOrder);
  console.log("purchaseOrder=========editState",editState);
  const componentRef = useRef();
  const navigate = useNavigate()
  const { enqueueSnackbar } = useSnackbar();
  const user = JSON.parse(localStorage.getItem('user'))
  const [currentRFQData, setCurrentRFQdata] = useState({})
  const [openEdit, setOpenEdit] = useState(false)
  const [showServices, setShowServices] = useState(true)
  const [selectedProducts, setSelectedProducts] = useState([])
  const [selectedMaterials, setSelectedMaterials] = useState([]);
  const [initialServiceCostInProductFormula, setInitialServiceCostInProductFormula] = useState(0)
  const [markupType, setMarkupType] = useState();
  const [designs, setDesigns] = useState([])
  const [details, setDetails] = useState(null)
  const [skills, setSkill] = useState(null)
  const [removedInitialFile, setRemovedInitialFile] = useState(false)
  const [removeFile, setRemoveFile] = useState('')
  console.log('bsjfgbfdsguf',removedInitialFile)
  const [workflow, setWorkFlow] = useState(null)
  const [allProducts, setAllproducts] = useState(null)
  const [allMaterials, setAllMaterials] = useState(null)
  const [invoice, setInvoice] = useState(null)
  const [open, setIsOpen] = useState(false)
  const [totalsum, setTotalSum] = useState(0);
  const [taxAmount, setTaxAmount] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [rfqSubTotal, setRFQSubTotal] = useState(0);
  const [DiscountTotal, setDiscountTotal] = useState(0);
  const [totalWholesalePrice, setTotalWholesalePrice] = useState(0);
  const [totalRetailPrice, setTotalRetailPrice] = useState(0);
  const [totalProductFormula, setTotalProductFormula] = useState(0);
  const [addClient, setAddClient] = useState(false)
  const [addVendor, setAddVendor] = useState(false)
  const [addProposal, setAddProposal] = useState(false)
  const [openInvoice, setOpenInvoice] = useState(false)
  const [requestAccept, setRequestAccept] = useState(false)
  const [requestReject, setRequestReject] = useState(false)
  const [allClients, setAllClients] = useState(null)
  const [currentDate, setCurrentDate] = useState(moment().format('YYYY-MM-DD'));
  const [currentTab, setCurrentTab] = useState(user.isVendor ? 'Details' : 'Details')
  const [openPreview, setOpenPreview] = useState(false)
  const [avatarUrl, setAvatarUrl] = useState([])
  const [openDelete, setOpenDelete] = useState(false)
  const [reOpen, setReopen] = useState(false)
  const [confirmInvoice, setConfirmInvoice] = useState(false)
  const [invoiceReject, setRejectInvoice] = useState(false)
  // const [reqAcceptClient,setReqAcceptClient] = useState(false)
  const [reason, setReason] = useState('')
  const [acceptedClients, setAcceptedClients] = useState(null)
  const [updates, setUpdates] = useState(null)
  const [isSaving, setIsSaving] = useState(false)
  const [previewData, setPreviewData] = useState({})
  const [locationStates, setLocationStates] = useState({});
  const [payments, setPayments] = useState(null)
  const [projectTypes, setProjectTypes] = useState([]);
  const [projectCategories, setProjectCategories] = useState([]);
  const [communities, setCommunities] = useState([]);
  const [refresh, setRefresh] = useState(false)
  const [refreshData, setRefreshData] = useState(false)
  const ref = useRef()
  const [openWorkflow, setWorkflowOpen] = useState(false)
  const [manual, setManual] = useState(false)
  const [signAgreements, setSignAgreements] = useState(null)
  const [portfolio, setPortfolio] = useState(null)
  const [customTemplate, setCustomTemplate] = useState(null)
  const [questionnaireTemplate, setQuestionnaireTemplate] = useState(null)
  const [allDataEmpty, setDataEmpty] = useState(true)
  const [proposalData, setProposalData] = useState(null)
  const [teamMembers, setTeamMember] = useState([])
  const [labourCostServices, setLabourCostServices] = useState([])
  const [selectedServices, setSelectedServices] = useState([]);
  const [filteredServices, setFilteredServices] = useState([])
  const [requestServices, setRequestServices] = useState([])
  const [loading, setLoading] = useState(false)
  const [budget, setBudget] = useState(0)
  const [totalMarkupPercentage, setTotalMarkupPercentage] = useState(0)
  const [totalMarkupAmount, setTotalMarkupAmount] = useState(0)
  const [proposalId, setProposalId] = useState(null)
  const [vendorId, setVendorId] = useState(null)
  const [additionalSelectedServices, setAdditionalSelectedServices] = useState([]);
  localStorage.setItem('requestId', id ? id : null)
  const userType = user.user_type
  const userId = user.user_id
  const explodedPermissions = user?.exploded_permissions
  const hasMarkupPermission = explodedPermissions?.some(permission => ['View Markup'].includes(permission)) ? true : false
  const [showWarning, setShowWarning] = useState(selectedServices.map(() => false));
  const [allLocationSame, setAllLocationSame] = useState(false)
  const [selectedTaxCategory,setSelectedTaxCategory]=  useState(null);
  const [taxCategories,setTaxCategories]=  useState([]);
  const fileInputRef = useRef();
  const [uploadProgress, setUploadProgress] = useState(null);
  const classes = useStyles();
  const [selectedPDF, setSelectedPDF] = useState(null);
  const [openPDFModal, setOpenPDFModal] = useState(false);
  const [pdfLoading, setPdfLoading] = useState(true);
  const [avalaraTax,setAvalaraTax] = useState(0)
  const [invoiceData,setInvoiceData] = useState(null)

  let productFormulaCost = 0
  const VALUE = [
    { id: 0, value: 'Products' },
    // { id: 10, value: 'Product formula cost (Material cost + Service cost with markup)' },
    // { id: 10, value: !user.isVendor ? 'Product formula cost' : null },
    // { id: 1, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Selling Price (per product)' : null) : null },
    // { id: 2, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Selling Price (per product)' : null) : null },

    // { id: 3, value: hasMarkupPermission ? 'Markup (%)' : null },
    { id: 6, value: "Price" },
    { id: 4, value: 'Unit' },
     { id: 5, value: 'Quantity' },
    // { id: 6, value: 'Location' },
    // { id: 7, value: 'Discount' },
    { id: 8, value: 'Subtotal' },
    { id: 9, value: '' }
  ];

      const MATERIAL_VALUE = [
    { id: 0, value: 'Materials' },
    { id: 6, value: "Price" },
    { id: 4, value: 'Unit' },
     { id: 5, value: 'Quantity' },
    { id: 8, value: 'Subtotal' },
    { id: 9, value: '' }
  ];

  const VALUEPreview = [
    { id: 0, value: 'Products' },
    // { id: 9, value: 'Product formula cost (Material cost + Service cost with markup)' },
    { id: 1, value: markupType ? ((markupType == 2 && hasMarkupPermission) ? 'Selling Price (per product)' : null) : null },
    { id: 2, value: markupType ? ((markupType == 1 && hasMarkupPermission) ? 'Selling Price (per product)' : null) : null },
    { id: 3, value: hasMarkupPermission ? 'Markup (%)' : null },

    { id: 4, value: 'Unit' },
    { id: 5, value: 'Quantity' },
    { id: 6, value: 'Discount' },
    { id: 7, value: 'Subtotal' },
    { id: 8, value: '' }
  ]

  const VALUE_SERVICES = [
    { id: 0, value: 'Service Name' },
    // { id: 1, value: 'Markup (%)' },
    { id: 2, value: 'Cost (Hourly)' },
    // { id: 3, value: 'Markup Cost (Hourly)' },
    { id: 4, value: 'Hours' },
    { id: 5, value: 'Total cost' },
    { id: 8, value: '' }
  ];

  const [data, setData] = useState({});
  const fetchDetails = async () => {
    try {
      const res = await axios.post(`${REST_API_END_POINT}settings/get-companyProfile-details`);
      if (res.data.status === 1) {
        setData(...res.data.data);
      }
    } catch (error) {
      console.log('get-companyProfile-details error : ', error);
    }
  };

  useEffect(() => {
    fetchDetails();
  }, []);


  // const handleFileChange = async (event) => {
  //   const file = event.target.files[0];

  //   if (!file) {
  //     return;
  //   }

  //   if (!validateFile(file)) {
  //     return;
  //   }
  //   const storageRef = imageref(storage, file.name);
  //   const uploadTask = uploadBytesResumable(storageRef, file);
  //   uploadTask.on(
  //     'state_changed',
  //     (snapshot) => {
  //       const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
  //       setUploadProgress(progress); 
  //     },
  //     (error) => {
  //       console.error(error.message);
  //       setUploadProgress(null);
  //       event.target.value = null;
  //     },
  //     () => {
  //       getDownloadURL(uploadTask.snapshot.ref).then((url) => {
  //         const newAttachment = {
  //           type: 'pdf',
  //           name: file.name,
  //           url: url,
  //         };
  //         setFieldValue('files_upload', newAttachment);
  //       }).catch((error) => {
  //         console.error(error.message);
  //       }).finally(() => {
  //         setUploadProgress(null);
  //         event.target.value = null;
  //       });
  //     }
  //   );
  // };

  // const validateFile = (file) => {
  //   const allowedFileTypes = ['application/pdf'];
  //   const maxFileSize = 2 * 1024 * 1024; // 2MB
  
  //   if (!allowedFileTypes.includes(file.type)) {
  
  //     return false;
  //   }
  
  //   if (file.size > maxFileSize) {
  
  //     return false;
  //   }
  
  //   return true;
  // };
  const handleFileChange = async (event) => {
    const files = Array.from(event.target.files); // Get all selected files as an array
  
    if (!files || files.length === 0) {
      return;
    }
  
    const validFiles = files.filter(validateFile); // Filter out invalid files
  
    if (validFiles.length === 0) {
      console.error("No valid files to upload.");
      return;
    }
  
    setUploadProgress(0); // Reset progress
  
    const uploadedFiles = []; // To store uploaded file data
  
    validFiles.forEach((file) => {
      const storageRef = imageref(storage, file.name); // Generate storage reference
      const uploadTask = uploadBytesResumable(storageRef, file);
  
      uploadTask.on(
        'state_changed',
        (snapshot) => {
          const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          setUploadProgress(progress); // Update progress for the current file
        },
        (error) => {
          console.error(error.message);
          setUploadProgress(null); // Reset progress on error
        },
        async () => {
          try {
            const url = await getDownloadURL(uploadTask.snapshot.ref); // Get file URL
            const newAttachment = {
              type: 'pdf',
              name: file.name,
              url: url,
            };
            uploadedFiles.push(newAttachment);
  
            // Update field value with all uploaded files
            setFieldValue('files_upload', [
              ...(values.files_upload || []), 
              ...uploadedFiles
            ]);
          } catch (error) {
            console.error(error.message);
          } finally {
            setUploadProgress(null); // Reset progress
          }
        }
      );
    });
  
    event.target.value = null; // Reset the input field
  };
  
  const validateFile = (file) => {
    const allowedFileTypes = ['application/pdf'];
    const maxFileSize = 2 * 1024 * 1024; // 2MB
  
    if (!allowedFileTypes.includes(file.type)) {
      return false;
    }
  
    if (file.size > maxFileSize) {
      return false;
    }
  
    return true;
  };
  
  const handleChangeTab = (event, newValue) => {
    setCurrentTab(newValue)
    setRefresh(true)
  }
  const HandleClickmenu = () => {
    setAddClient(true)
  }

  const fetchTaxCategory = async () => {
    try{
        const response = await axios.post(`${REST_API_END_POINT}product/get-tax-category`)
        if(response.data.status === 1){
            setTaxCategories(response.data.taxResult);
        }else{
          setTaxCategories([])
        }
    }catch(error){
        console.log("Error - ",error);
        setTaxCategories([])
    }
  }

  //add clients
  const fetchAllClients = async () => {
    try {
      const res = await axios.post(`${REST_API}webservice/request/fetch-all-clients-request`, { requestId: id })
      if(res.data.data){
        setAllClients(res.data.data)
      }else{
        setAllClients([])
      }
    } catch (error) {
      console.log(error, 'Error in fetching all clients')
    }
  }

  useEffect(() => {
    fetchAllClients()
  }, [addClient])
  const NewUserSchema = Yup.object().shape({
    name: Yup.string().required('Name is required'),
    description: Yup.string().required('Description is required'),
    //  avatarUrl: Yup.mixed().required('Image is required'),
    // skills:userType!=3 && Yup.array().min(1, 'Skill is required'),
    // workflow:userType!=3 && Yup.array().min(1, 'Workflow is required'),
    // start: Yup.mixed().required('Start Date is required'),
    // end: Yup.date()
    //   .nullable()
    //   .transform((value, originalValue) => {
    //     return originalValue ? new Date(originalValue * 1000) : null;
    //   })
    //   .when('start', (start, schema) => {
    //     return start
    //       ? schema.min(
    //         start,
    //         'Installation Date must be greater than the Start Date'
    //       )
    //       : schema;
    //   }),
    // products: userType == 1 && Yup.array().min(1, 'At least one product is required'),
    clients: userType != 3 && Yup.array().min(1, 'Vendor is required'),
        // markup_type: userType != 3 && Yup.object().nullable().required('Please select the markup type'),  ====29/01/25
    products: Yup.array().when(['userType', 'services'], {
      is: (userType, services) => userType !== 3 && services.length === 0,
      // then: Yup.array().min(1, 'At least one product or service is required'),
      otherwise: Yup.array().min(0) // or any other validation for userType === 3 or services.length > 0
    }),
    // services:userType!=3 && Yup.array().min(1, 'At least one service is required'), 

    // project_type:Yup.object().nullable().required('Job Type is required'),
    // project_category:Yup.object().nullable().required('Job Category is required'),
    // community:Yup.object().nullable().required('Project is required'),
  });
  //
  const LabelStyle = styled(Typography)(({ theme }) => ({
    ...theme.typography.subtitle2,
    // color: theme.palette.text.secondary,
    //   marginBottom: theme.spacing(1)
  }));
  const LabelStyleHead = styled(Typography)(({ theme }) => ({
    ...theme.typography.h5,
    // color: theme.palette.text.secondary,
  }))
  //delete official request 
  const handleDeleteRFQ = async () => {
    try {
      const data = { request_id: id }
      const res = await axios.post(`${REST_API}webservice/delete-proposal/id`, data)

      if (res.data.data == true) {
        enqueueSnackbar('Delete success', { variant: 'success' });
        setIsOpen(false)
        setOpenEdit(false)
                setSelectedTaxCategory(null);
                setCurrentRFQdata({}) // added on 3-01-2024
                // resetForm();
                setSelectedProducts([])
                setSelectedServices([]);
                setAdditionalSelectedServices([])
                setFilteredServices([])
                if(popupOn){
                  setOpenDelete(false)
                  handleDataChange("change")
                // closeView();
                }else{
                  navigate(PATH_DASHBOARD.rfp.root)
                }
      }
    } catch (error) {
      console.log(error, 'Error in deleting the request')
    }

  }
  //fetch request details
  const fetchRequestDetails = async () => {
    try {
      setLoading(true)
      let userData = vendorId || userId
      let vendor = vendorId ? 3 : userType
      console.log("#################Vendor", vendorId);
      const res = await axios.post(`${REST_API}webservice/view-proposal`, { request_id: id, userId: userData, userType: vendor });

      console.log("#################requestProposals", res.data);
      setDetails(res.data?.data[0])
      setAvalaraTax(res?.data?.requestProposals[0]?.tax)
      setTeamMember(res.data.team)
      setAvatarUrl(res.data.attachments)
      console.log('daaaaaataaaaaaaaaaa',res.data)
      setProposalId(res.data?.data[0].proposalId)
      setMarkupType(res.data?.data[0]?.markup_type)
      setDesigns(res.data?.attachments)
      setSkill(res.data.skill)
      setWorkFlow(res.data.workflows)
      setAllproducts(res.data.products)
      setAllMaterials(res?.data?.materials)
      setAcceptedClients(res.data.requestAcceptedPartners)
      setUpdates(res.data.updates)
      setPayments(res.data.payments)
      setCustomTemplate(res.data.fieldTemplates)
      setQuestionnaireTemplate(res.data.QuestionTemplates)
      setSignAgreements(res.data.signAgrementData)
      setDataEmpty(res.data.allDataEmpty)
      setPortfolio(res.data.portfolio)
      setRefresh(false)
      setProposalData(res.data.requestProposals)
      setLabourCostServices(res.data.labourCostServices)
      setFilteredServices(res.data.labourCostServices)
      setRequestServices(res.data.requestServices)
      console.log("ratataratatatata",res.data.requestServices)
      if (res.data?.data[0]?.is_location === 1) {
        setAllLocationSame(true)
      }
      if (editState) {
        setOpenEdit(true)

      }
      // setTimeout(()=>{
      //   setLoading(false)
      // },2000)

    } catch (error) {
      console.error('Error fetching request details:', error);
    } finally {
      setLoading(false)
    }
  };
  useEffect(() => {
    fetchRequestDetails()
    fetchTaxCategory()
  }, [id, refresh, openEdit, vendorId])

  const handleRemoveFile = (index) => {
    const removedFile = values.files_upload[index]; // Get the removed file
    console.log('Removing file:', removedFile);
  
    // Perform any server-side cleanup or state management here
  };
  
  useEffect(() => {
    try {
      axios.post(`${REST_API_END_POINT}project/get-data-for-add-project`, {
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response.data.status === 1) {
          setProjectTypes(response.data.projectTypes)
          setProjectCategories(response.data.projectCategories)
          // setCommunities(response.data.community)

        }
      }).catch((error) => {
        console.error(error);
      })
    }
    catch (error) {
      console.error("Error fetching data:", error);
    }
  }, [])
  //rfq product detais
  const fetchOrderProductDetails = async () => {
    try {
      let orderId = details?.id;
      let userData = vendorId || userId
      console.log("$$$$$$$$$$$$$$$$orderID", orderId);
      const res = await axios.post(`${REST_API}webservice/get-rfp-by-id`, { userId: userData, orderId });
      setInvoice(res.data.data);
      setCommunities(res.data.community)
      setDesigns(res.data?.attachments)
      setInvoiceData(res.data.data)
      console.log('fetchOrderProductDetails',res.data.data)
      return res.data;
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
  };
  const handleSendEmail = async () => {
    try {
      let orderId = details?.id;
      const res = await axios.post(`${REST_API}webservice/settings/send-mail`, { id: orderId });

      if (res.data.status === 1) {
        enqueueSnackbar('Email send successfully', { variant: 'success' });
        setOpenInvoice(false)
      }
      return res.data;
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
  };
  const fetchRequestServicesDetails = async () => {
    try {
      let orderId = details?.id;
      const res = await axios.post(`${REST_API}webservice/get-request-services/${orderId}`);
      setInvoice(res.data.data);
      return res.data.data;
    } catch (error) {
      console.error('Error fetching request details:', error);
      throw error;
    }
  };

  console.log("$$$$$$$$$$$$$$$$$$$$$CurrentRfq", currentRFQData);
  const addingInitialdataRFQ = async () => {
    // setLoading(true)
    try {
      if (openEdit) {
        let servicesArray = details?.services?.split(',')?.map(Number);
        let workflowSet = details?.workflows?.split(',')?.map(Number);
        const newInvoiceData = await fetchOrderProductDetails();
        const invoiceData = newInvoiceData?.data
        setInvoiceData(invoiceData)
        const rfqTaxCategory = taxCategories?.find(cat => invoiceData.tax_category == cat.id) || null
        setSelectedTaxCategory(rfqTaxCategory)
        const communityData = newInvoiceData?.community
        // let rfqSkill = skills?.filter((row) => row.id == details?.services);
        // let rfqSkill = skills.filter(skill => servicesArray.includes(skill.id));
        // let rfqWorkFlow = workflow?.filter(skill => workflowSet?.includes(skill.id));
        let rfqProjectType = projectTypes?.find(type => details.project_type === type.id)
        let rfqProjectcategory = projectCategories?.find(cat => details.project_category === cat.id)
        let rfqMarkupType = markupTypes?.find(cat => details?.markup_type === cat.id)
        let rfqCommunity = communityData?.find(com => details.community === com.id)

        // rfqProduct = invoiceData?.cust_product.filter((row) => {
        //   return allProducts.filter(data => data.id == row.product_id)
        // })
        let rfqProduct = invoiceData?.cust_product.map((row) => {
          let match = allProducts.find(data => data.id == row.product_id);
          if (match) {
            // If a match is found, return a new object with data from allProducts and quantity from invoiceData?.cust_product
            return {
              ...match,
              discount: row.discount,
              quantity: row.quantity,
              location: row.location,
              sellingPrice: row.sellingPrice || 0,
              locationQuantity: row.locationQuantity
            };
          } return undefined;
        }).filter(item => item !== undefined);
        console.log("####################RFQ", rfqProduct);
        console.log("invoiceData----", invoiceData);
        setSelectedProducts(rfqProduct || [])

        let rfqMaterial = invoiceData?.cust_product.map((row) => {
          let match = allMaterials.find(data => data.id == row.product_id);
          if (match) {
            return {
              ...match,
              discount: row?.discount,
              quantity: row?.quantity,
              location: row?.location,
              sellingPrice: row?.sellingPrice || 0,
              locationQuantity: row?.locationQuantity || 1
            };
          } return undefined;
        }).filter(item => item !== undefined);
        setSelectedMaterials(rfqMaterial || [])
        // const serviceIdArray = details?.labour_cost_services?.split(',')?.map(Number);
        // const rfqServices = invoiceData?.cust_product?.map((row)=>
        //   labourCostServices?.find(data => data.id == row.id)
        // )
        //   const rfqServices = invoiceData?.cust_product?.map(product => {
        //     const productServices = product.services?.map(service => {
        //         const serviceData = labourCostServices.find(data => data.id === service.id);
        //         return serviceData;
        //     });

        //     // Return an object containing product details along with its services
        //     return productServices;
        // });
        const rfqServicesData = await invoiceData?.cust_product?.flatMap(product => {
          console.log('product--rfqServicesData', product)
          // let match = allProducts.find(data => data.id == row.product_id);
          // return product.services.map(service => ({
          return requestServices.map(product => ({
            ...service,
            product_id: product.labour_cost_service_id,
            qtyData: product.quantity,
            sellingPrice:product.sellingPrice || row.cost || 0,
            locationQuantity: product.locationQuantity || 1
          }));
        });
        console.log("rfqServiceDatarfqServiceDatarfqServiceData", rfqServicesData);
        console.log("##################Additional", requestServices)
        // await setSelectedServices(rfqServicesData || [])
        const filteredServices = rfqServicesData?.length === 0
          ? labourCostServices
          : labourCostServices.filter((service) => !rfqServicesData.find((selectedService) => selectedService.labour_cost_service_id === service.id));
        setFilteredServices(filteredServices);

        const additionalServices = requestServices?.filter(item => item?.recipe_id === null);
        console.log("$$$$$$$$$$$$%%%%%%%%%%%%%@@@@@@@@", additionalServices);
        const additionalServicesData = additionalServices || [];

        setAdditionalSelectedServices(additionalServicesData);
 
       

        setCurrentRFQdata({
          name: details?.name,
          description: details?.description,
          notes: details?.notes,
          clients: acceptedClients || [],
          // skills: rfqSkill,
          // workflow: rfqWorkFlow,
          project_category: rfqProjectcategory,
          markup_type: rfqMarkupType,
          community: rfqCommunity,
          project_type: rfqProjectType,
          start: details?.submission_deadline,
          end: details?.participation_ends,
          labour_cost: details?.labour_cost,
          budget: invoiceData?.budget || 0,
          taxAmount: invoiceData?.taxAmount || 0,
          tariff:invoiceData?.tariff,
          shipping_cost:invoiceData?.shipping_cost,
          products: rfqProduct || null,
          services: additionalServicesData || null,
          invoice_discount: invoiceData?.extra_discount,
          welcome_message: details?.welcome_message == 1 ? true : false || null,
          total: invoiceData?.total,
          tax: invoiceData?.tax,
          draft: details?.status == 1 ? true : false || null,
          sub_total: invoiceData?.sub_total,
          order_id: details?.id || invoiceData?.id,
          subject: details?.subject || null,
          email_content: details?.email_content || null,
          // files_upload:designs? designs?.[0]?.name : null 
          // avatarUrl:details?.thumbnail||null
        });
      }
    } catch (error) {
      console.error('Error adding initial data for Sales Order:', error);
    } finally {
      // setTimeout(() => {
      //   setLoading(false)
      // }, 3000);
    }
  };

  useEffect(() => {
    console.log('detailsdetailsdetailsdetails 1', details)
    if (details) {
      console.log('detailsdetailsdetailsdetails 2', details.id)
      fetchOrderProductDetails();

    }
  }, [details, vendorId]);
  useEffect(() => {
    if (designs  && !removedInitialFile) {
      setCurrentRFQdata(prevState => ({
        ...prevState,
        // files_upload: designs ? designs?.[0]?.name : []
        files_upload: designs || []
      }));
    }
    console.log("jnfigfidbgiudhfdhg",values.files_upload.filter((d, i) => d.id !== removeFile.id));
    
    if (removedInitialFile) {
      setCurrentRFQdata(prevState => ({
        ...prevState,
        files_upload: values.files_upload.filter((d, i) => d.id !== removeFile.id)
       
      }));
      setRemoveFile('')
    }


  }, [designs, vendorId,removedInitialFile]);

  useEffect(() => {
    setLoading(true)
    addingInitialdataRFQ();
    setTimeout(() => {
      setLoading(false)
    }, 3000)
  }, [openEdit, vendorId, taxCategories]);

  // The below useEffect is used for fetching the invoice details only
  useEffect(() => {
    fetchOrderProductDetails();
    console.log('requestServices--', requestServices);
    const additionalServices = requestServices?.filter(item => item?.recipe_id === null);
    const additionalServicesData = additionalServices || [];
    setAdditionalSelectedServices(additionalServicesData);
  }, [openInvoice, vendorId, requestServices]);



  const invoiceDate = moment.unix(details?.timestamp).format('MM/DD/YYYY')

  //edit rfq
  const handleEditClick = () => {
    setOpenEdit(!openEdit)

  }
  const handleDeleteMenu = () => {
    setOpenDelete(!openDelete)
  }
  const handleReopen = () => {
    setReopen(!reOpen)
  }
  // const handleProduct = (value) => {

  //   const productsWithQuantity = value.map((product) => ({
  //     ...product,
  //     quantity: selectedProducts.filter((p) => p.id === product.id)[0]?.quantity || 1,
  //     location: [...Array(Number(selectedProducts.filter((p) => p.id === product.id)[0]?.quantity) || 1)].map((_, i) => ({
  //       id: i,
  //       address: '',
  //       city: '',
  //       state: '',
  //       zip: '',
  //     })),

  //   }));

  //    setSelectedProducts(productsWithQuantity);
  // };
  console.log("#################@@@@@@@@@@designname", designs);
  const handleProduct = (value) => {
    console.log("#################@@@@@@@@@@Value", value);

    setSelectedProducts(prevProducts => {
      const commonAddresses = (allLocationSame && prevProducts.length > 0) ? [...prevProducts[0].location] : null;

      const updatedProducts = value.map(product => {
        const dataRetailPrice = product.product_retail_price || product.retail_price;
        const dataWholesalePrice = product.product_price || product.price || 0;
        const existingProduct = prevProducts.find(p => p.id === product.id || p.id === product.product_id);
        console.log("###############ExistingProduct", existingProduct);

        if (existingProduct) {
          // If product already exists, update its quantity and addresses
          const quantity = existingProduct.quantity; // or set the default quantity
          const locationQuantity = existingProduct.locationQuantity;
          let location = [...existingProduct.location];
          let rowTotal = calculateTotal(
            markupType === 1 ? dataWholesalePrice : (markupType === 2 ? dataRetailPrice : 0),
            product.dataQuantity,
            product.dataDiscount,
            quantity,
            locationQuantity
          );

          // Ensure no duplicate addresses are added
          if (allLocationSame && commonAddresses) {
            location = [...commonAddresses];
          } else {
            for (let i = location.length; i < locationQuantity; i++) {
              location.push({
                id: i,
                address: '',
                city: '',
                state: '',
                zip: '',
              });
            }
          }

          console.log("###########Location----", location);
          return {
            ...existingProduct,
            quantity,
            rowTotal,
            location
          };
        } else {
          // If product doesn't exist, add it with default quantity and addresses
          const newAddresses = [{
            id: 0,
            address: '',
            city: '',
            state: '',
            zip: '',
          }];

          if (allLocationSame && prevProducts.length > 0) {
            const commonAddress = { ...prevProducts[0].location[0] } || {
              address: '',
              city: '',
              state: '',
              zip: '',
            };
            newAddresses[0] = commonAddress;
          }

          return {
            ...product,
            quantity: 1,  // Default quantity for new product
            locationQuantity: 1,
            discount: 0,
            rowTotal: calculateTotal(
              markupType === 1 ? dataWholesalePrice : (markupType === 2 ? dataRetailPrice : 0),
              product.dataQuantity,
              product.dataDiscount,
              1,
              1
            ),
            location: newAddresses,
          };
        }
      });

      const productServices = updatedProducts.reduce((services, product) => {
        if (product.services && product.services.length > 0) {
          return services.concat(product.services);
        }
        return services;
      }, []);

      // setSelectedServices(prevServices => {
      //   const filteredProductServices = productServices.filter(service => {
      //     return !prevServices.some(existingService => (
      //       existingService?.labour_cost_service_id === service?.id &&
      //       existingService?.recipe_id === service?.recipe_id &&
      //       existingService?.product_id === service?.product_id
      //     ));
      //   });

      //   let updatedServices = prevServices.map(service => ({
      //     ...service,
      //     quantity: service.quantity || 1, // Maintain the existing quantity or set default
      //     locationQuantity: service.locationQuantity || 1,
      //   }));

      //   updatedServices = updatedServices.filter(existingService => {
      //     return productServices.some(service => (
      //       (existingService?.labour_cost_service_id === service?.id || existingService?.id === service?.id) &&
      //       existingService?.recipe_id === service?.recipe_id &&
      //       existingService?.product_id === service?.product_id
      //     ));
      //   });

      //   const filteredProductServicesUnique = filteredProductServices.filter(service => {
      //     return !updatedServices.some(existingService => (
      //       (existingService?.labour_cost_service_id === service?.id || existingService?.id === service?.id) &&
      //       existingService?.recipe_id === service?.recipe_id &&
      //       existingService?.product_id === service?.product_id
      //     ));
      //   });

      //   return updatedServices.concat(filteredProductServicesUnique);
      // });

      const filteredServices = productServices.length === 0
        ? labourCostServices
        : labourCostServices.filter(service => !productServices.find(selectedService => selectedService.id === service.id));
      setFilteredServices(filteredServices);

      let initialServicesCost = 0;
      if (updatedProducts.length > 0) {
        initialServicesCost = updatedProducts.reduce((total, data) => {
          return total + (data.quantity * data.expected_total_service_cost);
        }, 0);
      }

      setInitialServiceCostInProductFormula(initialServicesCost);
      return updatedProducts;
    });
  };

  console.log("###############ExistingProduct111", selectedProducts);
  // const handleProduct = (value) => {
  //   setSelectedProducts(prevProducts => {
  //       const updatedProducts = value.map(product => {
  // 	      const dataRetailPrice = product.product_retail_price||product.retail_price
  //           const dataWholesalePrice = product.product_price||product.price||0
  //           const existingProduct = prevProducts.find(p => p.id === product.id || p.id === product.product_id);
  //           if (existingProduct) {
  //               const quantity = existingProduct.quantity; 
  //               const location = [...existingProduct.location];
  //               let rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? product.dataretailPrice : 0), product.dataQuantity, product.dataDiscount,quantity);

  //               for (let i = existingProduct.quantity; i < quantity; i++) {
  //                   location.push({
  //                       id: i,
  //                       address: '',
  //                       city: '',
  //                       state: '',
  //                       zip: '',
  //                   });
  //               }
  //               return {
  //                   ...existingProduct,
  //                   quantity,
  //                   rowTotal, 
  //                   location 
  //               };
  //           } else {
  //               return {
  //                   ...product,
  //                   quantity: 1, 
  //                   rowTotal: calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? product.dataRetailPrice : 0), product.dataQuantity, product.dataDiscount, 1),
  //                   location: [{
  //                       id: 0,
  //                       address: '',
  //                       city: '',
  //                       state: '',
  //                       zip: '',
  //                   }]
  //               };
  //           }
  //       });

  //       return updatedProducts;
  //   });

  //   setSelectedServices(prevServices => {
  //       const updatedServices = prevServices.map(service => ({
  //           ...service,
  //           quantity: service.quantity || 1,
  //       }));
  //       return updatedServices;
  //   });
  // };

  const handleMaterial = (value) => {
    console.log('valueeeeeeeeeeee', value)
    setSelectedMaterials(prevProducts => {
      const updatedProducts = value.map(product => {
        const dataRetailPrice = product.product_retail_price || product.retail_price
        const dataWholesalePrice = product.product_price || product.price || 0
        const existingProduct = prevProducts.find(p => p.id === product.id || p.id === product.product_id);
        if (existingProduct) {
          const quantity = existingProduct.quantity;
          const location = [...existingProduct.location];
          let rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? product.dataretailPrice : 0), product.dataQuantity, product.dataDiscount, quantity);

          for (let i = existingProduct.quantity; i < quantity; i++) {
            location.push({
              id: i,
              address: '',
              city: '',
              state: '',
              zip: '',
            });
          }
          return {
            ...existingProduct,
            quantity,
            rowTotal,
            location
          };
        } else {
          return {
            ...product,
            quantity: 1,
            rowTotal: calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? product.dataRetailPrice : 0), product.dataQuantity, product.dataDiscount, 1),
            location: [{
              id: 0,
              address: '',
              city: '',
              state: '',
              zip: '',
            }]
          };
        }
      });

      return updatedProducts;
    });
  };

  console.log('selectedServices-------', selectedServices);
  const handleAllLocationSameChange = () => {

    console.log("##################Alllll", allLocationSame);
    if (!allLocationSame) {
      const commonAddress = selectedProducts[0]?.location[0] || {
        address: '',
        city: '',
        state: '',
        zip: '',
      };
      console.log("##################Alllll", commonAddress);
      setSelectedProducts(prevProducts =>
        prevProducts.map(product => ({
          ...product,
          location: product.location.map(() => commonAddress),
        }))
      );
    }
    setAllLocationSame(!allLocationSame);
  };
  const handleDeleteProduct = (productId) => {
    const fileredProduct = selectedProducts.filter(data => (data.id || data.product_id) !== productId)
    setFieldValue('products', fileredProduct);
    setSelectedProducts(fileredProduct)
    const quantityFieldName = `quantity_${productId}`;
    const discountFieldName = `discount_${productId}`;
    setFieldValue(quantityFieldName, 1);
    setFieldValue(discountFieldName, 1);
    console.log('fileredProduct-------', fileredProduct);
    console.log('selectedServices-------', selectedServices);
    console.log("###############InitialserviceCost", initialServiceCostInProductFormula);
    const filteredServices = selectedServices?.filter(service => {
      // Check if there is any product in fileredProduct array which contains the service
      return fileredProduct?.some(product => (
        product.recipe_id === service.recipe_id &&
        product.id === service.product_id
      ));
    });


    // setSelectedServices(filteredServices);

    // setSelectedServices(filteredServices);
    let initialServicesCost = 0
    if (fileredProduct.length > 0) {
      initialServicesCost = fileredProduct?.reduce((total, data, index) => {
        return total + ((data?.quantity) * (data?.expected_total_service_cost));
      }, 0);
    }
    // console.log('initialServiceCost In ProductFormula-----', initialServicesCost);
    setInitialServiceCostInProductFormula(initialServicesCost)


  }

  const handleDeleteMaterial = (productId) => {
    const fileredProduct = selectedMaterials.filter(data => (data.id || data.product_id) !== productId)
    setFieldValue('materials', fileredProduct);
    setSelectedMaterials(fileredProduct)
    const quantityFieldName = `quantity_${productId}`;
    const discountFieldName = `discount_${productId}`;
    setFieldValue(quantityFieldName, 1);
    setFieldValue(discountFieldName, 1);
}
console.log('currentRFQDatacurrentRFQData',currentRFQData)
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      name: currentRFQData.name ||details?.name || '',
      // clients: currentRFQData.clients,
      clients: allClients?.filter(item => (currentRFQData.clients || acceptedClients)?.some(client => client.id === item.id)) || [],
      description: currentRFQData.description ||details?.description || '',
      notes: currentRFQData.notes || '',
      // skills: currentRFQData.skills || [],
      // workflow: currentRFQData.workflow || [],
      project_type: currentRFQData.project_type || null,
      project_category: currentRFQData.project_category || null,
      community: currentRFQData.community || null,
      start: currentRFQData.start || currentDate,
      end: currentRFQData.end || currentDate,
      // avatarUrl: currentRFQData.avatarUrl||'',
      products: currentRFQData.products || [],
      materials: [],
      services: currentRFQData.services || [],
      markup_type: currentRFQData.markup_type || null,
      invoice_discount: currentRFQData.invoice_discount || '',
      welcome_message: currentRFQData.welcome_message || false,
      draft: currentRFQData.draft || false,
      total: currentRFQData.total || '',
      labour_cost: currentRFQData.labour_cost || 0,
      budget: currentRFQData.budget || 0,
      tax: 0,
      order_id: currentRFQData.order_id || '',
      subject: currentRFQData.subject || '',
      email_content: currentRFQData.email_content || '',
      files_upload:currentRFQData.files_upload || [],
      shipping_cost:invoiceData?.shipping_cost || 0,
      tariff:invoiceData?.tariff || 0
    },
    validationSchema: NewUserSchema,
    onSubmit: async (values, { setSubmitting, resetForm, setErrors }) => {
      try {
        console.log("onsubmit=================");
        
        const request_id = id
        values.products = selectedProducts
        values.materials = selectedMaterials
        values.order_id = details?.id
        // const allServices = [...selectedServices, ...additionalSelectedServices];
        const allServices = [...additionalSelectedServices];
        const servicesIdArray = allServices?.map(service => service.id);
        values.services = servicesIdArray?.join(',')
        values.totalMarkup = totalMarkup
        values.selectedServices = allServices
        const data = {
          values, userId, userType, request_id,
          taxCategory : selectedTaxCategory?.id || null,
          allLocationSame,
          address: selectedProducts.reduce((acc, product) => {
            return [
              ...acc,
              ...product.location.map((address) => ({
                ...address,
                productId: product.id,
              })),
            ];
          }, []),
        }
        const isvalidationNotOk = selectedProducts.find(product => {
          if (product.location.length && product.location.some(obj =>
            Object.values(obj).some(value => value === '')
          )) {
            return true
          } else {
            return false
          }
        })
        values.total = totalsum
        values.taxAmount = taxAmount
        values.budget = budget

        // console.log("######isvalidationNotOk", isvalidationNotOk);
        // console.log("######totalAmount", values.total);
        // console.log("######totalAmountbudget", values.budget);

        // if(isvalidationNotOk){
        //   enqueueSnackbar('Please fill all the address fields', { variant: 'error' });
        // }else{

        if(values.products.length==0 && values.services.length ==0){
          return enqueueSnackbar('Please add atleast one product or service', { variant: 'error' });
        }

        if (user.isVendor) {
          // console.log("###########proposalId", proposalId);

          if (!empty(proposalId)) {
            data.proposalId = proposalId
            await axios.post(`${REST_API}webservice/rfq/update-proposal`, data)
              .then((res) => {
               
                setOpenEdit(false)
                setIsOpen(false)
                setSelectedTaxCategory(null);
                setCurrentRFQdata({}) // added on 3-01-2024
                resetForm();
                setSelectedProducts([])
                setSelectedServices([]);
                setAdditionalSelectedServices([])
                setFilteredServices([])
                if(popupOn) {
                  handleDataChange("change")
                  // closeView()
                  }else{
                       if (edit) {
                    navigate(`/dashboard/rfp`)
                  }
                }
                
                enqueueSnackbar('Update success', { variant: 'success' });
              })

              .catch((errors) => {
                console.log(errors, 'error')
              })
          }

          else {
            await axios.post(`${REST_API}webservice/rfq/add-proposal`, data)
              .then((res) => {

                setOpenEdit(false)
                setIsOpen(false)
                setCurrentRFQdata({}) // added on 3-01-2024
                resetForm();
                setSelectedTaxCategory(null);
                setSelectedProducts([])
                setSelectedServices([]);
                setAdditionalSelectedServices([])
                setFilteredServices([])
                // fetchRequestDetails()
                if(popupOn) {
                  handleDataChange("change")
                  // closeView()
                  }else{
                       if (edit) {
                    navigate(`/dashboard/rfp`)
                  }
                }
                enqueueSnackbar('Update success', { variant: 'success' });
              })

              .catch((errors) => {
                console.log(errors, 'error')
              })
          }

        }
        else {


          await axios.post(`${REST_API}webservice/update-proposal`, data)
            .then((res) => {

              setOpenEdit(false)
              setIsOpen(false)
              setCurrentRFQdata({}) // added on 3-01-2024
              resetForm();
              setSelectedTaxCategory(null);
              setSelectedProducts([])
              setSelectedServices([]);
              setAdditionalSelectedServices([])
              setFilteredServices([])
              fetchRequestDetails()
              // handleDataChange()
              if(popupOn) {
                handleDataChange("change")
                // closeView()
                }else{
                     if (edit) {
                  navigate(`/dashboard/rfp`)
                }
              }
              enqueueSnackbar('Update success', { variant: 'success' });
            })

            .catch((errors) => {
              console.log(errors, 'error')
            })
        }
        // }
      } catch (error) {
        console.error(error);

      }
    }
  });


  // useEffect(()=>{
  //   // let currentUnix = moment(currentDate).unix()
  //   //  let requestSubmitDeadline = details?.submission_deadline

  //    if((user?.user_id == details?.partner_user_id)&& (details?.accept_status == 0)){
  //     setReqAcceptClient(true)
  //    }

  // },[details])

  const submissionDeadlineUnix = details?.submission_deadline;
  const submissionDeadlineMoment = moment.unix(submissionDeadlineUnix);

  const current = moment();

  const daysLeft = submissionDeadlineMoment.diff(current, 'days');

  const handleAcceptorRejectInvoice = async (value) => {
    try {
      if (value === 2 && reason === '') {
        enqueueSnackbar('Please fill rejected reason ', { variant: 'warning' })
        return
      }
      else {

        let requestId = id
        let requestPartnerId = details?.rt_partner_id
        let acceptStatus = value
        let userId = user.user_id

        const data = { requestId, requestPartnerId, acceptStatus, userId, reason }
        const res = await axios.post(`${REST_API}webservice/request/accept-or-reject-invoice`, data)

        if (res.data.status == 1) {
          setOpenInvoice(!openInvoice)
          setConfirmInvoice(false)
          enqueueSnackbar('Invoice Accepted', { variant: 'success' });
          fetchRequestDetails()
        } else if (res.data.status == 2) {

          setOpenInvoice(!openInvoice)
          setRejectInvoice(false)
          enqueueSnackbar('Invoice Rejected', { variant: 'error' })
          setReason('')
          closeView()
          navigate(PATH_DASHBOARD.official.root)
        }
        else {
          setOpenInvoice(!openInvoice)
          setConfirmInvoice(false)
        }
      }
    } catch (error) {
      console.log(error, 'error in accepting invoice')
    }
  }

  const handleReopeningRequest = async () => {
    try {
      let requestId = id
      let userId = user.user_id
      const data = { requestId, userId }
      const res = await axios.post(`${REST_API}webservice/request/reopen`, data)
      if (res.data.status == 1) {
        enqueueSnackbar('Request reopened successfully', { variant: "success" })
        setReopen(false)
        fetchRequestDetails()
      } else if (res.data.status == 0) {
        enqueueSnackbar('Request reopened failed', { variant: "error" })
        setReopen(false)
      }
    } catch (error) {
      console.log(error, 'Error in reopen')
    }
  }

  const { errors, values, touched, handleSubmit, isSubmitting, setFieldValue, getFieldProps } = formik;



  const setValuesToPreview = () => {
    setPreviewData(values)
  }

  // let  totalsum = 0
  // let DiscountTotal=0
  // let newTotalProductFormula1 = 0;
  // let newTotalWholesalePrice1 = 0;
  // let newTotalRetailPrice1 = 0;

  const calculateTotal = (price, quantity, discount, value, location = 1) => {

    const parsedQuantity = parseFloat(quantity ? quantity : value) || 1;
    const parsedDiscount = parseFloat(discount) || 0;
    const locationQuantity = parseFloat(location) || 1
    const subtotal = price * parsedQuantity * locationQuantity;

    if (discount) {
      const totalDiscount = subtotal - discount;
      return totalDiscount;
    } else {
      return subtotal;
    }
  };
  let sum = 0
  let taxAmountData = 0 ;
  let grandTotalData = 0;
  let totalJobcostSum = 0
  let newTaxSum = 0;
  useEffect(() => {
    try {
      console.log('selectedProducts-----', selectedProducts);
      // if(selectedProducts?.length > 0 || selectedServices?.length > 0 || additionalSelectedServices?.length > 0){
      let selectedProductsTotalDiscount = selectedProducts?.reduce((total, data, index) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price
        const dataWholesalePrice = data.product_price || data.price

        const dataQuantity = data?.quantity || 1

        const dataDiscount = data?.discount || 0;

        // const productTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? dataRetailPrice : 0), dataQuantity, dataDiscount,null,data?.locationQuantity);

        const productTotal = calculateTotal(data.sellingPrice || 0, dataQuantity, dataDiscount, null, data?.locationQuantity);

        return total + productTotal;
      }, 0);

      const selectedProductsTotalDiscountForJobCost = selectedProducts?.reduce((total, data, index) => {
        const quantityFieldName = `quantity_${data.product_id || data.id}`;
        const discountFieldName = `discount_${data.product_id || data.id}`;
        const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
        const discountVal = values[discountFieldName] ? values[discountFieldName] : 0
        // console.log("###############quantityVal", quantityVal)
        // console.log("###############quantityValdata", data)
        // const productTotal = calculateTotal(data.expected_material_cost, data.quantity, discountVal);
        const productTotal = calculateTotal(data.expected_material_cost, data.quantity, 0, null, data.locationQuantity);
        // console.log("###############product formula", productTotal)
        return total + productTotal;
      }, 0);

      let selectedMaterialsSum = selectedMaterials?.reduce((total, data, index) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price
        const dataWholesalePrice = data.product_price || data.price

        const dataQuantity = data?.quantity || 1

        const dataDiscount = data?.discount || 0;

        // const productTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? dataRetailPrice : 0), dataQuantity, dataDiscount,null,data?.locationQuantity);

        const productTotal = calculateTotal(data.sellingPrice || 0, dataQuantity, dataDiscount, null, data?.locationQuantity);

        return total + productTotal;
      }, 0);
      console.log('selectedMaterialsSum', selectedMaterialsSum)
      // const allServices = [...selectedServices, ...additionalSelectedServices];
      const allServices = [ ...additionalSelectedServices];
      let selectedServicesCost = selectedServices?.reduce((total, service, index) => {  //allServices
        // const quantityFieldName = `service_quantity_${index}`;
        // const quantityVal = values[quantityFieldName]?values[quantityFieldName]:1
        const quantityVal = service?.quantity ? Number(service?.quantity) : 1
        const serviceTotal = calculateTotal(service.cost, quantityVal, 0);

        // console.log("############SSSSSSSSSSSer", serviceTotal);

        // let selectedQuantity=selectedProducts.filter(product=>product.id===service.product_id)
        // console.log("############SSSSSSSSSSSer",selectedQuantity);
        // let quantity=selectedQuantity[0].quantity
        // return total + (serviceTotal*quantity);
        return total + serviceTotal;
      }, 0);
      // selectedServicesCost = selectedServicesCost - initialServiceCostInProductFormula
      console.log('allServices-----------', allServices);

      const selectedServicesTotalCost = allServices?.reduce((total, service, index) => {
        // const quantityFieldName = `service_quantity_${index}`;
        // const quantityVal = values[quantityFieldName] ? values[quantityFieldName] : 1
        const quantityVal = service?.quantity ? Number(service?.quantity) : 1
        const costVal = service?.unit_cost ? Number(service?.unit_cost) : Number(service?.total_cost)
        // const serviceTotal = calculateTotal(costVal, quantityVal, 0);
        const serviceTotal = calculateTotal(service.sellingPrice || 0, quantityVal, 0);
        return total + serviceTotal;
      }, 0);
      const initialServicesCost = 0 //selectedProducts?.reduce((total, data, index) => {
      //   return total + ((data?.quantity) * (data?.expected_total_service_cost) * (data?.locationQuantity || 1));
      // }, 0);

      // New tax calculation
      const selectedTaxServicesTotalCost = allServices?.reduce((total, service, index) => {
        // console.log('servicesssss',service?.taxable)
        // Skip non-taxable services
        if (service?.taxable === 0) return total;
        console.log('servicesssss',true)
        const quantityVal = service?.quantity ? Number(service?.quantity) : 1;
        const costVal = service?.unit_cost ? Number(service?.unit_cost) : Number(service?.total_cost);
        const serviceTotal = calculateTotal(service.sellingPrice || 0, quantityVal, 0);
        return total + serviceTotal;
      }, 0);
      console.log('selectedTaxServicesTotalCost',selectedTaxServicesTotalCost)
      const selectedServicesSubTotal = selectedServicesTotalCost - initialServicesCost
      const selectedNewTaxServicesSubTotal = selectedTaxServicesTotalCost - initialServicesCost
      values['labour_cost'] = selectedServicesSubTotal // selectedServicesCost
      const newSum = (selectedProductsTotalDiscount + selectedServicesTotalCost + selectedMaterialsSum) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
      setRFQSubTotal(newSum)
      // console.log("###################11111selectedServicesTotalCost", selectedServicesTotalCost);
      // console.log("###################1111initialServicesCost", initialServicesCost);
      // console.log("###################1111selectedServicesSubTotal", selectedServicesSubTotal);
      // console.log("###################1selectedProductsTotalDiscount", selectedProductsTotalDiscount);
      sum = (selectedProductsTotalDiscount + selectedServicesSubTotal + selectedMaterialsSum) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
      newTaxSum = (selectedProductsTotalDiscount + selectedNewTaxServicesSubTotal + selectedMaterialsSum) - (values['invoice_discount'] ? values['invoice_discount'] : 0)
      taxAmountData = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (sum * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
      const newTaxAmountData = selectedTaxCategory ? (selectedTaxCategory.type === 1 ? (newTaxSum * (selectedTaxCategory.value || 0) / 100) : (selectedTaxCategory.value || 0) ) : 0;
      console.log('tax dataaaaa old >',taxAmountData)
      console.log('tax dataaaaa new >',newTaxAmountData)
      
      setTotalSum(sum);
      // setTaxAmount(taxAmountData);
      if(proposalData &&proposalData[0]?.avalara_code){
        setTaxAmount(proposalData[0].tax)
        grandTotalData = (parseFloat(sum) + parseFloat(proposalData[0].tax)).toFixed(2);

      }else{
        grandTotalData = (parseFloat(sum) + parseFloat(taxAmountData)).toFixed(2);
        setTaxAmount(taxAmountData)
      }
      setGrandTotal(grandTotalData);

      let selectedProductsTotalProductFormula = selectedProducts?.reduce((total, data) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price;
        const dataWholesalePrice = data.product_price || data.price;
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1);

        let newTotalProductFormula = data.expected_cost * data.quantity * data.locationQuantity;
        newTotalProductFormula = newTotalProductFormula ? Number(newTotalProductFormula) : 0;

        console.log('newTotalProductFormula--', newTotalProductFormula);

        return total + newTotalProductFormula;
      }, 0);

      selectedProductsTotalProductFormula = selectedProductsTotalProductFormula ? Number(selectedProductsTotalProductFormula) : 0

      setTotalProductFormula(selectedProductsTotalProductFormula)

      let selectedProductsTotalWholesalePrice = selectedProducts?.reduce((total, data, index) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price
        const dataWholesalePrice = data.product_price || data.price
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1)

        let newTotalWholesalePrice = dataWholesalePrice * data.quantity * data.locationQuantity
        newTotalWholesalePrice = newTotalWholesalePrice ? Number(newTotalWholesalePrice) : 0

        // console.log('newTotalWholesalePrice--', newTotalWholesalePrice);

        return total + newTotalWholesalePrice;
      }, 0);
      selectedProductsTotalWholesalePrice = selectedProductsTotalWholesalePrice ? Number(selectedProductsTotalWholesalePrice) : 0

      setTotalWholesalePrice(selectedProductsTotalWholesalePrice)

      let selectedProductsTotalRetailPrice = selectedProducts?.reduce((total, data, index) => {
        let quantityFieldName = `quantity_${data.product_id ? data.product_id : data.id}`;
        let discountFieldName = `discount_${data.product_id ? data.product_id : data.id}`;
        const dataRetailPrice = data.product_retail_price || data.retail_price
        const dataWholesalePrice = data.product_price || data.price
        const dataQuantity = values[quantityFieldName] ? values[quantityFieldName] : (data?.quantity || 1)

        let newTotalRetailPrice = dataRetailPrice * data.quantity * data.locationQuantity
        newTotalRetailPrice = newTotalRetailPrice ? Number(newTotalRetailPrice) : 0

        // console.log('newTotalRetailPrice--', newTotalRetailPrice);

        return total + newTotalRetailPrice;
      }, 0);
      selectedProductsTotalRetailPrice = selectedProductsTotalRetailPrice ? Number(selectedProductsTotalRetailPrice) : 0

      setTotalRetailPrice(selectedProductsTotalRetailPrice)
      //discount count
      let selectedProductDiscount = selectedProducts?.reduce((acc, data, index) => {
        // const discountFieldName = `discount_${data.product_id?data.product_id:data.id}`;
        // const discountVal = values[discountFieldName]?values[discountFieldName]:(data?.discount||0);
        const discountVal = data.discount ? data.discount : 0
        let productDiscount = +discountVal || 0;
        return acc + productDiscount;
      }, 0);
      const newDiscountTotal = selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0);
      setDiscountTotal(selectedProductDiscount + (parseFloat(values['invoice_discount']) || 0));

      // console.log("#############selectedProductsTotalProductFormula", selectedProductsTotalProductFormula);
      // console.log("#############selectedProductsTotalWholesalePrice", selectedProductsTotalWholesalePrice);
      // console.log("#############selectedProductsTotalRetailPrice", selectedProductsTotalRetailPrice);
      let selectedProductsTotalMarkupAmount = markupType == 1 ? ((selectedProductsTotalWholesalePrice - newDiscountTotal) - selectedProductsTotalProductFormula)
        : (markupType == 2 ? ((selectedProductsTotalRetailPrice - newDiscountTotal) - selectedProductsTotalProductFormula) : 0);
      setTotalMarkupAmount(selectedProductsTotalMarkupAmount)


      let selectedProductsTotalMarkup = markupType == 1 ? ((((selectedProductsTotalWholesalePrice - newDiscountTotal) - selectedProductsTotalProductFormula) / selectedProductsTotalProductFormula) * 100)
        : (markupType == 2 ? ((((selectedProductsTotalRetailPrice - newDiscountTotal) - selectedProductsTotalProductFormula) / selectedProductsTotalProductFormula) * 100) : 0);
      setTotalMarkupPercentage(selectedProductsTotalMarkup)

        // console.log('selectedProductsTotalDiscount-------',selectedProductsTotalDiscount);
        // console.log('selectedProductsTotalDiscountForJobCost-------',selectedProductsTotalDiscountForJobCost);
        / console.log('selectedServicesCost-------', selectedServicesCost);
      // console.log('selectedServicesTotalCost-------',selectedServicesTotalCost);
      // console.log('selectedServicesSubTotal-------',selectedServicesSubTotal);
      // console.log('sum-------',sum);
      console.log('selectedProductsTotalMarkup-------', selectedProductsTotalMarkup);

      totalJobcostSum = (selectedProductsTotalDiscountForJobCost + selectedServicesCost);
      console.log('total job cost------- budget', totalJobcostSum);
      values['total'] = sum
      values['taxAmount'] = taxAmountData
      values['budget'] = totalJobcostSum
      console.log("################Budget", totalJobcostSum);
      setBudget(totalJobcostSum)


      console.log('initialServiceCost In ProductFormula-----', initialServicesCost);
      setInitialServiceCostInProductFormula(initialServicesCost)
      // }else{
      //   console.log('eeeeeeeeeeeeeeeeee');
      // }
    } catch (error) {
      console.log('Error--------------', error);
    }
  }, [currentRFQData, selectedTaxCategory, selectedProducts,selectedMaterials, selectedServices, additionalSelectedServices, values.markup_type, values.invoice_discount, refreshData])

  ////image functionality
  const handleRemoveAll = () => {
    setAvatarUrl([]);
  };

  const handleRemove = (file) => {
    const filteredItems = avatarUrl.filter((_file) => _file !== file);
    setAvatarUrl([filteredItems]);
  };

  ///////
  const handleDrop = useCallback(
    (acceptedFiles) => {
      if (acceptedFiles && acceptedFiles.length > 0) {
        const file = acceptedFiles[0];
        const Filename = new Date().getTime() + file.name;

        const StorageRef = imageref(storage, Filename);
        const uploadTask = uploadBytesResumable(StorageRef, file);

        uploadTask.on(
          'state_changed',
          (snapshot) => {
            const progress = Math.round((snapshot.bytesTransferred / snapshot.totalBytes) * 100);
          },
          (error) => {
            console.error(error.message);
          },
          () => {
            getDownloadURL(uploadTask.snapshot.ref).then((downloadURL) => {
              setFieldValue('avatarUrl', downloadURL)

            });
          }
        );
      }
    },
    [setFieldValue]
  );

  let subTotal = 0
  const ACCOUNT_TABS = [
    {
      value: `${user.isVendor ? '' : ''}Details`,
      component: details ? (
        <ViewRequest
          teamMembers={teamMembers}
          clientDetails={invoice}
          products={invoice?.cust_product}
          fetchRequestDetails={fetchRequestDetails}
          user={user}
          designs={designs}
          fromProposal={true}
          setDesigns={setDesigns}
          details={details}
          isRequest={true}
          requestId={id}
          signAgreements={signAgreements}
          customTemplate={customTemplate}
          questionnaireTemplate={questionnaireTemplate}
          allDataEmpty={allDataEmpty}
          portfolio={portfolio}
          invoice={invoice}
          quotation={1}
          proposalView={1}
        />
      ) : "",
    },
    // {
    //   value: 'client message board',
    //   component: (
    //     <PublicMessageBoard
    //       products={invoice?.cust_product}
    //       requestDetails={details}
    //       requestId={id}
    //       acceptedClients={acceptedClients}
    //     />
    //   ),
    // },
    // ...(user.isVendor ? [] : [
    //   {
    //     value: 'change order',
    //     component: <RequestTabUpdates updates={updates?.length > 0 ? updates : []} />,
    //   },
    //   {
    //     value: 'payments',
    //     component: <PaymentRequest totalValue={invoice?.total} />,
    //   },
    //   {
    //     value: 'Locations',
    //     component: <Locations products={invoice?.cust_product} designs={designs} />,
    //   },
    // ]),
    ...(userType === 3 ? (user.isVendor ? [
      {
        value: 'My Proposal',
        component: <Proposals setReloadData={() => setRefresh(!refresh)} acceptedClients={acceptedClients} proposalData={proposalData} handleEditClick={handleEditClick} setVendorId={setVendorId} fetchAllClients={fetchAllClients} allClients={allClients} setAllClients={setAllClients} id={id} />,
      },
    ] : []) : [
      {
        value: 'Proposals',
        component: <Proposals setReloadData={() => setRefresh(!refresh)}  acceptedClients={acceptedClients} proposalData={proposalData} handleEditClick={handleEditClick} setVendorId={setVendorId} fetchAllClients={fetchAllClients} allClients={allClients} setAllClients={setAllClients}
          id={id} handleDataChange={handleDataChange} />,
      },
    ]),
  ];

  const handleDeleteService = (servId) => {
    const newFilteredServices = additionalSelectedServices?.filter(data => data.id !== servId);
    // const allFilteredServices = filteredServices?.find(data => data.id !== servId);
    setFieldValue('services', newFilteredServices);
    setAdditionalSelectedServices(newFilteredServices);
  };
  useEffect(() => {
    if (selectedProducts.length <= 0) {
      setAllLocationSame(false)
    }
  }, [selectedProducts])
  const handleCancel = async (isEdit) => {
    // setOpenEdit(false)
    // setIsOpen(false)
    setCurrentRFQdata({})
    // resetForm();
    setSelectedProducts([])
    setSelectedServices([]);
    setAdditionalSelectedServices([])
    setFilteredServices([])
    fetchRequestDetails()
    setVendorId(null)
    setAllLocationSame(false)
    setRefresh(!refresh)
    
      if(editState){
        if(popupOn) {
          // handleDataChange("change")
          closeView()
          }else{
                if (edit) {
              navigate(`/dashboard/rfp`)
          }
        }

      }else{
        editState=false
        setOpenEdit(false)
      setIsOpen(false)
      setIsEditPurchaseOrder(false)
      localStorage.removeItem('isEditPurchaseOrder');
      if(!openEdit){
        if(popupOn) {
          // handleDataChange("change")
          closeView()
          }else{
              navigate(`/dashboard/rfp`)
          
      }
      }
    }
      if(!popupOn && !isEdit){
        navigate(`/dashboard/rfp`)
      }
    
  }

  useEffect(() => {
    console.log('useEffect---All Clients:', allClients);
    console.log('useEffect---Accepted Clients:', values.clients);
  }, [allClients, values.clients]);

  let totalMarkup = 0;
  let totalServiceMarkup = 0;
  let originaltotalMarkup = 0
  let originaltotalServiceMarkup = 0
  let totalAmount = 0;
  return (
    <Page title="View Request: View | Sign Wise Solutions">

      {loading ? <Stack sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', alignContent: 'center',mt:7 }} >
        <LoadingScreen />
      </Stack> :

        <Container sx={{mt:2}}>


          <Button
            variant="outlined"
            type="submit"
            // onClick={()=>navigate(PATH_DASHBOARD.official.root)}
            onClick={() => { 
                openEdit ? handleCancel(true) : handleCancel()
           }}
            sx={{ alignItems: 'flex-end', mb: 4 }}
            startIcon={ // Use the startIcon prop to add an icon to the left
              <Stack>
                <KeyboardBackspaceOutlined />
              </Stack>

            }
          >
            Back 
          </Button>
          <Stack
            direction="row"
            alignItems="center"
            justifyContent="space-between"
          >
            <HeaderBreadcrumbs
              heading={details?.name}
            />
            {!openEdit && (
              <Stack marginBottom={5} flexDirection={'column'}>
                <Stack direction={'row'} alignItems={'center'} spacing={1}>
                  {/* {details?.status !==1 && userType!=3 && details?.status !==4 && <Button
                  size="small"
                  variant="contained"
                  disabled ={(explodedPermissions?.some(permission => ['Add client to request'].includes(permission))) ? false : true}
                  onClick={HandleClickmenu}
                  sx={{ height: 34 }}
                  startIcon={<Icon icon={plusFill} />}
                >
                {acceptedClients?.length ? "Add Collaborator" : "Add Client"}
                </Button>} */}
                  {/* {userType!=3 && details?.status ===4 && <Button
                  size="small"
                  variant="contained"
                  disabled ={(explodedPermissions?.some(permission => ['Add vendor to request'].includes(permission))) ? false : true}
                  onClick={()=>setAddVendor(true)}
                  sx={{ height: 34 }}
                  startIcon={<Icon icon={plusFill} />}
                >
                Add Vendor
                </Button>} */}
                  {/* {(user.isVendor === 1 && proposalData && !proposalData?.length > 0) && (<Button
                    size="small"
                    variant="contained"
                    disabled={explodedPermissions?.some(permission => ['Submit Proposal'].includes(permission)) ? false : true}
                    onClick={() => setAddProposal(true)}
                    sx={{ height: 34 }}
                    startIcon={<Icon icon={plusFill} />}
                  >
                    Submit Proposal
                  </Button>)} */}
                  {/* <Typography variant="overline" >
                <Label
                  sx={{ p: '17px' }}
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color={getStatusColorAndLabel(details?.status).color} >
                  {getStatusColorAndLabel(details?.status).label}
                </Label>
              </Typography> */}
                  {/* {userType != 3 && (
                    <IconButton ref={ref} onClick={() => { (explodedPermissions?.some(permission => ['Edit Request', 'Delete request'].includes(permission))) ? setIsOpen(!open) : (enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })) }}>
                      <Icon icon={moreVerticalFill} width={20} height={20} />
                    </IconButton>
                  )} */}
                </Stack>
                {(userType != 3 || user?.isVendor === 1) ?
                  // <Stack>

                  //   <Menu
                  //     open={open}
                  //     anchorEl={ref.current}
                  //     onClose={() => setIsOpen(false)}
                  //     PaperProps={{
                  //       sx: { width: 200, maxWidth: '100%' }
                  //     }}
                  //     anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
                  //     transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                  //   >
                  //     {/* {details?.status !==1 &&(
                  // <MenuItem onClick={HandleClickmenu} sx={{ color: 'text.secondary' }}>
                  //   <ListItemIcon >
                  //     <AddCircle />
                  //   </ListItemIcon>
                  //   <ListItemText primary={acceptedClients?.length ? "Add Collaborators" : "Add Client"} primaryTypographyProps={{ variant: 'body2' }} /> 
                  // </MenuItem>)} */}
                  //     {details?.status !== 6 && empty(details?.installationStatus) && (
                  //       <MenuItem onClick={() => { (explodedPermissions?.some(permission => ['Edit Request'].includes(permission))) ? handleEditClick() : !empty(details?.installationStatus) ? (enqueueSnackbar("Access Denied: Moved to Installation Phase", { variant: 'error' })) : (enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })) }}
                  //       //  sx={{ color: 'text.secondary' }}
                  //       >
                  //         <ListItemIcon>
                  //           <Icon icon={editFill} width={24} height={24} />
                  //         </ListItemIcon>
                  //         <ListItemText primary="Edit" primaryTypographyProps={{ variant: 'body2' }} />
                  //       </MenuItem>
                  //     )}
                  //     <MenuItem onClick={() => { (explodedPermissions?.some(permission => ['Delete request'].includes(permission))) ? handleDeleteMenu() : (enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' })) }}
                  //     // sx={{ color: 'text.secondary' }}
                  //     >
                  //       <ListItemIcon>
                  //         <Icon icon={trash2Outline} width={24} height={24} />
                  //       </ListItemIcon>
                  //       <ListItemText primary="Delete" primaryTypographyProps={{ variant: 'body2' }} />
                  //     </MenuItem>
                  //     {details?.status == 6 && (
                  //       <MenuItem onClick={handleReopen}
                  //       // sx={{ color: 'text.secondary' }}
                  //       >
                  //         <ListItemIcon>
                  //           <Icon icon={lockOpenFill} width={24} height={24} />
                  //         </ListItemIcon>
                  //         <ListItemText primary="Reopen" primaryTypographyProps={{ variant: 'body2' }} />
                  //       </MenuItem>
                  //     )}
                  //   </Menu>
                  // </Stack> 
                  <>
                    {(details && invoice) ?<Stack flexDirection={'row'} gap={2}>
                      {details?.status !== 6 && !details?.installationStatus && details?.proposal_count === 0 && (
                        <Tooltip title="Edit">
                          <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={() => {
                            (explodedPermissions?.some(permission => ['Edit Request'].includes(permission)) || user?.isVendor == 1)
                              ? handleEditClick()
                              : details?.installationStatus
                                ? enqueueSnackbar("Access Denied: Moved to Installation Phase", { variant: 'error' })
                                : enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                          }}>
                            <Icon icon={editFill} width={24} height={24} color="#ffffff" />
                          </IconButton>
                        </Tooltip>
                      )}
                      {(userType != 3) ?
                      <Tooltip title="Delete">
                        <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={() => {
                          explodedPermissions?.some(permission => ['Delete request'].includes(permission))
                            ? handleDeleteMenu()
                            : enqueueSnackbar("Access Denied: You do not have sufficient permissions", { variant: 'error' });
                        }}>
                          <Icon icon={trash2Outline} width={24} height={24} color="#ffffff" />
                        </IconButton>
                      </Tooltip> : ''}
  
                      {/* {details?.status === 6 && (
                        <Tooltip title="Reopen">
                          <IconButton sx={{ backgroundColor: theme.palette.divider }} onClick={handleReopen}>
                            <Icon icon={lockOpenFill} width={24} height={24} color="#ffffff" />
                          </IconButton>
                        </Tooltip>
                      )} */}
                    </Stack>:""}
                  </>
                  : ""}
              </Stack>)}
          </Stack>
          {openEdit && (
            <FormikProvider value={formik}>
              <Form noValidate autoComplete="off" onSubmit={handleSubmit}>
                <Grid container spacing={3}>

                  <Grid item xs={12} md={12}>
                    <Card sx={{ p: 3 }}>
                      <Stack spacing={3}>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Stack flexDirection={'column'}>
                            {/* <LabelStyle>Name</LabelStyle> */}
                            {!vendorId && <TextField
                              //   fullWidth
                              sx={{ width: 400 }}
                              label="Requested Name"
                              {...getFieldProps('name')}
                              disabled={!user.isVendor}
                              error={Boolean(touched.name && errors.name)}
                              helperText={touched.name && errors.name}
                            />}
                          </Stack>
                        </Stack>
                        {/* <LabelStyle>Description</LabelStyle> */}
                        {!vendorId && <TextField
                          fullWidth
                          multiline
                          minRows={3}
                          maxRows={7}
                          disabled={!user.isVendor}
                          label="keep the summary brief and make it communicates"
                          {...getFieldProps('description')}
                          error={Boolean(touched.description && errors.description)}
                          helperText={touched.description && errors.description}
                        />}
                        {!user.isVendor ? !vendorId &&
                          <Autocomplete
                            multiple
                            // sx={{ width: '50%' }}
                            fullWidth

                            id="combo-box-demo"
                            options={allClients?.filter(a => a.isVendor)}
                            value={values.clients}
                            onChange={(event, newValue) => {
                              setFieldValue('clients', newValue);


                            }}

                            renderInput={(params) => (
                              <TextField required
                                {...params} label="Vendors"
                                error={Boolean(touched.clients && errors.clients)}
                                helperText={touched.clients && errors.clients} />
                            )}
                            getOptionLabel={(option) => option.name}
                          /> : ""}
                        {/* <LabelStyle>Upload Approved Design</LabelStyle> */}
                        {/* <UploadAvatar
                        accept="image/*"
                        file={values.avatarUrl}
                        maxSize={3145728}
                        onDrop={handleDrop}
                        error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                      /> */}
                        {/* <UploadMultiFile
                         showPreview
                        maxSize={3145728}
                        accept="image/*"
                         files={avatarUrl}
                        onDrop={handleDrop}
                        onRemove={handleRemove}
                        onRemoveAll={handleRemoveAll}
                    // error={Boolean(touched.avatarUrl && errors.avatarUrl)}
                    /> */}


                        <Stack direction='row'>
                        <LabelStyle>{(userType !=3 && !vendorId) ? 'Upload File' :values.files_upload && values.files_upload.length > 0 ? 'Uploaded File' : ""}</LabelStyle>
                        </Stack>

                        {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Grid item xs={12} sm={12} md={12}>
                        <Box
                          width={'100%'}
                          display={ (userType !=3 && !vendorId) ? 'flex' : 'none'}
                          justifyContent={'flex-start'}
                        >
                        <Button
                          variant="outlined"
                          onClick={() => fileInputRef.current.click()}
                          startIcon={<UploadFile />}
                        >
                          Upload 
                          </Button>
                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        accept=".pdf"
                      />
                    </Box>
                    {uploadProgress !== null && (
                        <Box sx={{ width: '100%',mt: 1.5, mb: 2 }}>
                          <LinearProgress variant="determinate" value={uploadProgress} />
                          <Typography variant="caption" sx={{ mt: 1.5, display: 'block', textAlign: 'center' }}>
                            Uploading: {uploadProgress}%
                          </Typography>
                        </Box>
                      )}
                    {values.files_upload && (
                      <Box key={values.files_upload.name} my={1}>
                        <Box
                          sx={{
                            display: (userType !=3 && !vendorId) ? 'flex' : 'none',
                            justifyContent: 'flex-end',
                            mb: 3,
                          }}
                        >
                          <MButton
                            color="error"
                            size="small"
                            startIcon={<Icon icon={trash2Outline} />}
                            onClick={() => {
                              setRemovedInitialFile(true)
                              setFieldValue('files_upload', null);

                            }}
                            sx={{ mt: -1 }}
                          >
                            Delete
                          </MButton>
                        </Box>
                        <iframe
                          src={values?.files_upload.url || values?.files_upload}
                          type="application/pdf"
                          width="100%"
                          height="400px"
                          style={{borderRadius:'10px',border:'1px #2f444b solid'}}
                        />
                      </Box>
                    )}
                    </Grid>
                          </Stack> */}
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Grid item xs={12} sm={12} md={12}>
                        <Box
                      width={'100%'}
                      // display={'flex'}
                      // display={ userType !=3 ? 'flex' : 'none'}
                      display={ (userType !=3 && !vendorId) ? 'flex' : 'none'}
                      justifyContent={'flex-start'}
                    >
                        <Button
                        variant="outlined"
                        onClick={() => fileInputRef.current.click()}
                        startIcon={<UploadFile />}
                      >
                        Upload multiple files
                      </Button>
                      <input
                        type="file"
                        ref={fileInputRef}
                        onChange={handleFileChange}
                        style={{ display: 'none' }}
                        accept=".pdf"
                        multiple 
                      />
                    </Box>
                    {uploadProgress !== null && (
                        <Box sx={{ width: '100%',mt: 1.5, mb: 2 }}>
                          <LinearProgress variant="determinate" value={uploadProgress} />
                          <Typography variant="caption" sx={{ mt: 1.5, display: 'block', textAlign: 'center' }}>
                            Uploading: {uploadProgress}%
                          </Typography>
                        </Box>
                      )}
                    {/* {values.files_upload && (
                      <Box key={values.files_upload.name} my={1}>
                        <Box
                          sx={{
                            display: 'flex',
                            justifyContent: 'flex-end',
                            mb: 3,
                          }}
                        >
                          <MButton
                            color="error"
                            size="small"
                            startIcon={<Icon icon={trash2Outline} />}
                            onClick={() => setFieldValue('files_upload', null)}
                            sx={{ mt: -1 }}
                          >
                            Delete
                          </MButton>
                        </Box>
                        <iframe
                          src={values.files_upload.url}
                          type="application/pdf"
                          width="100%"
                          height="400px"
                          style={{borderRadius:'10px',border:'1px #2f444b solid'}}
                        />
                      </Box>
                    )} */}
                     {/* {values.files_upload && values.files_upload.length > 0 && (
                            <Box>
                              {values.files_upload.map((file, index) => (
                                <Box key={file.name + index} my={1}>
                                  <Box
                                    sx={{
                                      display: 'flex',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      mb: 2,
                                    }}
                                  >
                                    <Typography variant="body2">{file.name}</Typography>
                                    <MButton
                                      color="error"
                                      size="small"
                                      startIcon={<Icon icon={trash2Outline} />}
                                      onClick={() => {
                                        const updatedFiles = values.files_upload.filter((_, i) => i !== index);
                                        setFieldValue('files_upload', updatedFiles);
                                      }}
                                    >
                                      Delete
                                    </MButton>
                                  </Box>
                                  <iframe
                                    src={file.url}
                                    type="application/pdf"
                                    width="100%"
                                    height="400px"
                                    style={{ borderRadius: '10px', border: '1px #2f444b solid' }}
                                  />
                                </Box>
                              ))}
                            </Box>
                          )} */}

{values.files_upload && values.files_upload.length > 0 && (
  <Box>
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(4, 1fr)', // Three files per row
        gap: '16px', // Spacing between items
        mt: 3,
      }}
    >
      {values.files_upload.map((file, index) => {
        // Normalize data for edit mode
        const fileName = file.name.includes('http')
          ? decodeURIComponent(file.name.split('/').pop().split('?')[0])
          : file.name;
        const fileUrl = file.name.includes('http') ? file.name : file.url;

        return (
          <Box
            key={fileName + index}
            sx={{
              width: '200px',
              height: '200px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              borderRadius: '10px',
              border: '1px solid #2f444b',
              overflow: 'hidden',
              position: 'relative',
            }}
          >
            {/* File Name and Delete Button */}
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: '8px',
                backgroundColor: '#f5f5f5',
              }}
            >
         <Tooltip key={index} title={'Click For Preview'}>

              <Typography
                variant="body2"
                noWrap
                sx={{ maxWidth: '180px', color: "#11b2e3", cursor: "pointer" }}
                // onClick={() => window.open(fileUrl, '_blank', 'noopener,noreferrer')}
                onClick={() => {
                  setPdfLoading(true);
                  setSelectedPDF(fileUrl);
                  setOpenPDFModal(true);
                }}
              >
                Click For Preview
                {/* {fileName} */}
              </Typography>
              </Tooltip>
              {
                (userType !=3 && !vendorId)?
              
              <MButton
                color="error"
                size="small"
                startIcon={<Icon icon={trash2Outline} />}
                onClick={() => {
                  const updatedFiles = values.files_upload.filter((_, i) => i !== index);
                  setFieldValue('files_upload', updatedFiles);
                  setRemoveFile(index);
                  setRemovedInitialFile(true);
                }}
              >
                Delete
              </MButton>
                :""
              }
            </Box>

            {/* File Preview */}
            {/* <iframe
              src={fileUrl}
              type="application/pdf"
              width="100%"
              height="100%"
              style={{
                border: 'none',
              }}
            /> */}
            {(file.type === 'application/pdf' || file.name?.toLowerCase().endsWith('.pdf')) ? (
            <iframe
              src={fileUrl}
              type={file.type}
              width="100%"
              height="100%"
              style={{
                border: 'none',
              }}
              onClick={() => {
                setPdfLoading(true);
                setSelectedPDF(fileUrl);
                setOpenPDFModal(true);
              }}
            />
          ) : (
            <iframe
              src={file.url}
              type={file.type}
              width="100%"
              height="100%"
              style={{
                border: 'none',
              }}
            />
          )}
          </Box>
        );
      })}
    </Box>
  </Box>
)}


{/* previos one abin*/}
                          {/* {values.files_upload && values.files_upload.length > 0 && (
                          <Box>
                            {values.files_upload.map((file, index) => {
                              // Normalize data for edit mode
                              const fileName = file.name.includes('http') ? decodeURIComponent(file.name.split('/').pop().split('?')[0]) : file.name;
                              const fileUrl = file.name.includes('http') ? file.name : file.url;

                              return (
                                <Box key={fileName + index} my={1}>
                                  <Box
                                    sx={{
                                      // display: 'flex',
                                      // display: userType !=3 ? 'flex' : 'none',
                                      display: (userType !=3 && !vendorId) ? 'flex' : 'none',
                                      justifyContent: 'space-between',
                                      alignItems: 'center',
                                      mb: 2,
                                    }}
                                  >
                                    <Typography variant="body2">{fileName}</Typography>
                                    <MButton
                                      color="error"
                                      size="small"
                                      startIcon={<Icon icon={trash2Outline} />}
                                      onClick={() => {
                                        const updatedFiles = values.files_upload.filter((_, i) => i !== index);
                                        setFieldValue('files_upload', updatedFiles);
                                        // handleRemoveFile(index);
                                        setRemoveFile(index)
                                        setRemovedInitialFile(true)
                                      }}
                                    >
                                      Delete
                                    </MButton>
                                  </Box>
                                  <iframe
                                    src={fileUrl}
                                    type="application/pdf"
                                    width="100%"
                                    height="400px"
                                    style={{ borderRadius: '10px', border: '1px #2f444b solid' }}
                                  />
                                </Box>
                              );
                            })}
                          </Box>
                        )} */}

                    </Grid>
                          </Stack>

                        {/* <LabelStyle>Skills or services required</LabelStyle> */}
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          {/* <Autocomplete
                          multiple
                          fullWidth
                          id="combo-box-demo"
                          options={skills}
                          value={values.skills}
                          onChange={(event, newValue) => setFieldValue('skills', newValue)}
                          renderInput={(params) => (
                            <TextField {...params} label="Skills or services required" />
                          )}
                          getOptionLabel={(option) => option.name}
                        /> */}
                          {/* {communities && communities.length > 0 ? ( <Autocomplete
                          fullWidth
                          id="community"
                          options={communities}
                          value={values.community}
                          onChange={(event, newValue) => setFieldValue('community', newValue)}
                          renderInput={(params) => (
                            <TextField  required 
                            {...params} label="Project"
                            error={Boolean(touched.community && errors.community)}
                            helperText={touched.community && errors.community} />
                          )}
                          getOptionLabel={(option) => option.name}
                        />):
                          <Typography sx={{color:"red", width: '50%'}}>The client you have chosen does not have a project yet. Please create one for them! </Typography>
                        }
                      </Stack>
                      
                      <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                         <Autocomplete                        
                          fullWidth
                          id="combo-box-demo-type"
                          options={projectTypes}
                          value={values.project_type}
                          onChange={(event, newValue) => setFieldValue('project_type', newValue)}
                          renderInput={(params) => (
                            <TextField  required 
                            {...params} label="Job Type"
                            error={Boolean(touched.project_type && errors.project_type)}
                            helperText={touched.project_type && errors.project_type} />
                          )}
                          getOptionLabel={(option) =>option.name}

                        />
                         <Autocomplete
                         fullWidth
                          id="combo-box-demo-category"
                          options={projectCategories}
                          value={values.project_category}
                          onChange={(event, newValue) => setFieldValue('project_category', newValue)}
                          renderInput={(params) => (
                            <TextField  required 
                            {...params} label="Job Category"
                            error={Boolean(touched.project_category && errors.project_category)}
                            helperText={touched.project_category && errors.project_category} />
                          )}
                          getOptionLabel={(option) => option.name}

                        /> */}
                          {/* {!user.isVendor ? !vendorId &&
                            <Autocomplete
                              fullWidth
                              id="combo-box-demo-type"
                              options={markupTypes}
                              value={values.markup_type}
                              onChange={(event, newValue) => {
                                setFieldValue('markup_type', newValue)
                                setMarkupType(newValue?.id)
                              }}
                              renderInput={(params) => (
                                <TextField required
                                  {...params} label="Markup Type"
                                  error={Boolean(touched.markup_type && errors.markup_type)}
                                  helperText={touched.markup_type && errors.markup_type} />
                              )}
                              getOptionLabel={(option) => option.name}
                            /> : ""} */}
                        </Stack>
                        {/* <Stack>
                      <Autocomplete
                          multiple
                          fullWidth
                          id="combo-box-demo"
                          options={workflow}
                          value={values.workflow}
                          onChange={(event, newValue) => setFieldValue('workflow', newValue)}
                          renderInput={(params) => (
                            <TextField {...params} label="Workflow" />
                          )}
                          getOptionLabel={(option) => option.name}

                          />
                      </Stack> */}
                        {/* <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                      <Box
                       component={MobileDatePicker}
                      label="Start Date"
                      minDate={moment()}
                      defaultValue={moment.unix(values.start).format('MM/DD/YYYY')}
                      value={moment.unix(values.start)}
                       onChange={(date) => setFieldValue('start', moment(date).unix())}
                       renderInput={(params) => (
                      <TextField size="small" {...params} fullWidth />
                       )}
                       />

                        <Box
                          component={MobileDatePicker}
                          label="Installation Date"
                          minDate={moment()}
                          defaultValue={moment.unix(values.end).format('MM/DD/YYYY')}
                          value={moment.unix(values.end)}
                           onChange={(date) => setFieldValue('end', moment(date).unix())}
                           renderInput={(params) => (
                          <TextField size="small" {...params} fullWidth 
                            error={Boolean(touched.end && errors.end)}
                            helperText={touched.end && errors.end}
                          />
                           )}
                        />
                      </Stack> */}

                        <Divider />
                        <LabelStyleHead>Products</LabelStyleHead>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                        <Autocomplete
  sx={{ width: 400 }}
  multiple
  id="combo-box-demo"
  options={allProducts || []}
  value={selectedProducts}
  disabled={user.isVendor || vendorId}
  onChange={(event, newValue) => {
    if (newValue.some((option) =>
      values.products.some((product) => product.product_id === option.id)
    )) {
      return;
    }
    handleProduct(newValue);
    setFieldValue('products', newValue);
  }}
  filterOptions={(options, { inputValue }) => {
    return options.filter((option) => {
      const searchText = inputValue.toLowerCase();
      return (
        option.name?.toLowerCase().includes(searchText) ||
        option.description?.toLowerCase().includes(searchText)
      );
    });
  }}
  getOptionLabel={(option) => option.description || ''}
  renderOption={(props, option) => (
    <li {...props}>
      {option.description}
    </li>
  )}
  isOptionEqualToValue={(option, value) => option.id === value.id}
  renderInput={(params) => (
    <TextField
      {...params}
      label="Select a product"
      error={Boolean(touched.products && errors.products)}
      helperText={touched.products && errors.products}
    />
  )}
/>
                        </Stack>
                        <LabelStyle>Selected Products</LabelStyle>
                        <Scrollbar>
                          <TableContainer sx={{ minWidth: 500 }}>
                            <Table>
                              <TableHead>
                                <TableRow>
                                  {VALUE?.map((val) => (
                                    val.id === 10 ? (
                                      <Tooltip key={val.id} title="Product Formula Cost Per Unit * Quantity">
                                        <TableCell>{val.value}</TableCell>
                                      </Tooltip>
                                    ) : (
                                      <TableCell key={val.id}>{val.value}</TableCell>
                                    )
                                  ))}
                                  {/* {VALUE?.map((val) => (
                                  <TableCell>{val.value}</TableCell>
                                ))} */}
                                </TableRow>
                              </TableHead>
                              <TableBody>

                                {selectedProducts?.map((data, index) => {
                                  console.log("##################Data%%%%%%%%%",data);
                                  let id=data?.product_id || data?.id
                                  const quantityFieldName = `quantity_${id}`;
                                  const discountFieldName = `discount_${id}`;

                                  let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                  unitName = unitName[0]?.name
                                  let shortUnitName = ''
                                  if (unitName == 'Square feet') {
                                    shortUnitName = 'Sq ft'
                                  } else if (unitName == 'Lineal feet') {
                                    shortUnitName = 'Lin ft'
                                  } else if (unitName == 'Square Inches') {
                                    shortUnitName = 'Sq Inches'
                                  } else if (unitName == 'Unit') {
                                    shortUnitName = 'Unit'
                                  }
                                  // const dataPrice = data?.product_price || data?.price
                                  // const dataretailPrice = data?.product_retail_price || data?.retail_price
                                  // const dataWholesalePrice = data?.product_price || data?.price
                                  // // const dataQuantity = values[quantityFieldName]
                                  const dataQuantity = data?.quantity || 1
                                
                                   const dataDiscount = data?.discount ? data.discount : 0
                                  // // const rowTotal = calculateTotal(markupType == 1 ? dataWholesalePrice : (markupType == 2 ? dataretailPrice : 0), dataQuantity, dataDiscount,data.quantity,data.locationQuantity);
                                  const rowTotal = calculateTotal(data?.sellingPrice || 0, dataQuantity, dataDiscount, data?.quantity, data?.locationQuantity);

                                  // // const markup = ((dataretailPrice - dataPrice) / dataPrice) * 100;
                                  // const invoiceAmount = data?.expected_material_cost + data?.expected_total_service_cost
                                  // // let markup = markupType ? (invoiceAmount / rowTotal) : null

                                  // let markup = markupType == 1 ? (((dataWholesalePrice - data?.expected_cost) / data.expected_cost) * 100)
                                  //   : (markupType == 2 ? (((dataretailPrice - data?.expected_cost) / data.expected_cost) * 100) : 0);
                                  // markup = markup ? Number(markup) : 0
                                  // data['markup'] = markup
                                  // let markupData = data.product_markup?.toFixed(2) || data.markup?.toFixed(2)
                                  // markupData = Number(markupData) * data.quantity
                                  // data['markup'] = markupData
                                  // totalMarkup += Number(data.product_markup) || Number(data.markup) || 0
                                  // data['markup_type'] = markupType
                                  // data['totalMarkup'] = totalMarkup?.toFixed(2)
                                  // let originalMarkup = markupType == 1 ? data?.wholesaleMarkup : markupType == 2 ? data.retailMarkup : 0
                                  // originaltotalMarkup += originalMarkup
                                  // // values['totalMarkup'] = totalMarkup?.toFixed(2)
                                  // productFormulaCost += data.expected_cost * data.quantity * data.locationQuantity

                                  // const pfc = data.expected_cost * data.quantity * data.locationQuantity // total product formula cost
                                  // const rtp = dataretailPrice * data.quantity * data.locationQuantity // total retail price
                                  // const wsp = dataWholesalePrice * data.quantity * data.locationQuantity // total wholesale price

                                  // const maxDiscount_wholesale = wsp - pfc
                                  // const maxDiscount_retail = rtp - pfc

                                  // // const maxDiscount_wholesale = (wsp - pfc) - DiscountTotal
                                  // // const maxDiscount_retail = (rtp - pfc) - DiscountTotal

                                  // console.log('maxDiscount_wholesale--', maxDiscount_wholesale);
                                  // console.log('maxDiscount_retail--', maxDiscount_retail);
                                  // console.log('DiscountTotal--', DiscountTotal);
                                  // console.log('pfc--', pfc);
                                  // console.log('rtp--', rtp);
                                  // console.log('wsp--', wsp);

                                  return (
                                    <>
                                      <TableRow key={data?.id}>
                                        <TableCell>{data?.product_name || data?.name}</TableCell>


                                        <TableCell>

                                          <TextField
                                            type="number"
                                            sx={{ width: 85 }}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                            }}
                                            onWheel={(e)=>e.target.blur()}
                                            inputProps={{ min: 0 }}
                                            fullWidth
                                            label={"Unit Price"}
                                            // {...getFieldProps(quantityFieldName)}
                                            disabled={!user.isVendor}
                                            defaultValue={data?.sellingPrice ? data?.sellingPrice : 0}
                                            value={data?.sellingPrice ? data?.sellingPrice : 0}
                                            onChange={(event) => {

                                              let newValue = event.target.value;


                                              setSelectedProducts(pv => ([...pv.map(p => {
                                                if (p.id === data.id) {

                                                  return {
                                                    ...p,
                                                    // quantity:newValue,
                                                    sellingPrice: newValue
                                                  }
                                                }
                                                else{
                                                  return p
                                                }
                                              })]));

                                            }}

                                          // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>

                                        <TableCell>
                                          <TextField
                                            type="number"
                                            sx={{ width: 85 }}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            disabled={(user.isVendor || vendorId || shortUnitName == 'Unit') ? true : false}
                                            label={shortUnitName}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data?.quantity ? data?.quantity : 1}
                                            value={data?.quantity ? data?.quantity : 1}

                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }

                                              setSelectedProducts(pv => ([...pv.map(p => {
                                                if (p.id === data.id) {



                                                  return {
                                                    ...p,
                                                    quantity: newValue,

                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              console.log("###############SElected services", selectedServices);
                                              // setSelectedServices(pv => ([...pv.map(service => {
                                              //   if (service.product_id === data.id && service.prQty) {
                                              //     return {
                                              //       ...service,
                                              //       quantity: (service.prQty * (newValue) * (service?.locationQuantity || 1)).toFixed(2),
                                              //       qtyData: Number(newValue),
                                              //     };
                                              //   } else {
                                              //     return {
                                              //       ...service,

                                              //     }
                                              //   }
                                              // })]));


                                              data['quantity'] = newValue || 1;

                                              setFieldValue(quantityFieldName, newValue);
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            sx={{ width: 85 }}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            disabled={user.isVendor || vendorId}
                                            label={"Qty"}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data?.locationQuantity ? data?.locationQuantity : 1}
                                            value={data?.locationQuantity ? data?.locationQuantity : 1}

                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }

                                              setSelectedProducts(pv => ([...pv.map(p => {
                                                if (p.id === data.id) {



                                                  return {
                                                    ...p,
                                                    locationQuantity: newValue,

                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              console.log("###############SElected services", selectedServices);
                                              // setSelectedServices(pv => ([...pv.map(service => {
                                              //   if (service.product_id === data.id && service.prQty) {
                                              //     return {
                                              //       ...service,
                                              //       quantity: (service.prQty * (newValue) * (service?.locationQuantity || 1)).toFixed(2),
                                              //       qtyData: Number(newValue),
                                              //     };
                                              //   } else {
                                              //     return {
                                              //       ...service,

                                              //     }
                                              //   }
                                              // })]));


                                              data['quantity'] = newValue || 1;

                                              setFieldValue(quantityFieldName, newValue);
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          {rowTotal.toFixed(2)}
                                        </TableCell>
                                        {!user.isVendor ? !vendorId && <TableCell >
                                          <IconButton onClick={() => handleDeleteProduct(data?.id || data?.product_id)}>
                                            <Delete />
                                          </IconButton>
                                        </TableCell> : ""}
                                      </TableRow>





                                    </>
                                  );
                                })}
                              </TableBody>
                            </Table>
                          </TableContainer>
                        </Scrollbar>

                        <Divider />
                        <Stack direction='row'>
                          <LabelStyleHead>Services</LabelStyleHead>
                          {showServices ? <Remove sx={{ color: theme.palette.primary.main }} onClick={(e) => { setShowServices(false) }} /> : <Add sx={{ color: theme.palette.primary.main }} onClick={(e) => { setShowServices(true) }} />}
                        </Stack>
                        {showServices && <>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                            <Autocomplete
                              sx={{ width: 400 }}
                              multiple
                              id="combo-box-demo"
                              disabled={user.isVendor || vendorId}
                              options={
                                filteredServices?.filter(item =>
                                  item.status === 1 &&
                                  !additionalSelectedServices.some(selectedService =>
                                    selectedService?.id === item?.id || selectedService?.labour_cost_service_id === item?.id
                                  )
                                ) || []
                              }
                              value={additionalSelectedServices}

                              onChange={(event, newValue) => {
                                setFieldValue('services', newValue);
                                setAdditionalSelectedServices(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} required
                                  error={Boolean(touched.services && errors.services)}
                                  helperText={touched.services && errors.services}
                                  label="Select additional services" />
                              )}
                              getOptionLabel={(option) => option.name ? option.name : ''}
                            />
                          </Stack>
                          <LabelStyle>Selected services</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {VALUE_SERVICES?.map((val) => (
                                      <TableCell>{val.value}</TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>

                                <TableBody>
                                  {console.log('selectedServices1----', selectedServices)}
                                  {selectedServices?.map((data, index) => {
                                    console.log('dataaaaaaaaaaaaaaaa',data)
                                    const quantityFieldName = `service_quantity_${index}`;
                                    const dataCost = data.unit_cost || data.total_cost
                                    const total = dataCost * data.quantity
                                    totalAmount += total
                                    data['totalAmount'] = totalAmount?.toFixed(2)
                                    const markup = dataCost / total
                                    data['markup'] = markup?.toFixed(2)
                                    totalServiceMarkup += markup
                                    data['total'] = total?.toFixed(2)
                                    data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    let originalMarkup = data.originalMarkup || 0
                                    originaltotalServiceMarkup += originalMarkup
                                    // values['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    console.log("############WWWWW", originalMarkup);
                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{data.name}</TableCell>
                                          <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                          <TableCell>{data.cost}</TableCell>
                                          <TableCell>{dataCost}</TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              // sx={{ width: 400 }}                                                                                
                                              label={'Hours'}
                                              // {...getFieldProps(quantityFieldName)}
                                              value={Number(data.quantity)}
                                              defaultValue={data.quantity ? Number(data.quantity) : 1}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                const newData = { ...data, quantity: newValue || 1 };
                                                if (newValue.startsWith('-')) {
                                                  newValue = newValue.slice(1);
                                                }
                                                if (newValue < data.prQty) {
                                                  setShowWarning(prev => {
                                                    const newWarnings = [...prev];
                                                    newWarnings[index] = true;
                                                    return newWarnings;
                                                  });
                                                  console.log('data?.prQty---', data?.prQty);
                                                  data['quantity'] = data?.prQty;
                                                  setFieldValue(quantityFieldName, data?.prQty);
                                                } else {
                                                  setShowWarning(prev => {
                                                    const newWarnings = [...prev];
                                                    newWarnings[index] = false;
                                                    return newWarnings;
                                                  });
                                                  data['quantity'] = newValue || 1;
                                                  setFieldValue(quantityFieldName, newValue);
                                                }

                                                const updatedServices = [...selectedServices];
                                                updatedServices[index] = newData;
                                                updatedServices[index] = newData;

                                                updatedServices[index] = newData;

                                                // setSelectedServices(updatedServices);
                                              }}
                                              inputProps={{ min: data.prQty }}
                                              error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                            {showWarning[index] && (
                                              <Typography color="error" variant='body2'>
                                                Cannot reduce the added hours in the product formula. If you need to reduce, change it in the product formula.
                                              </Typography>
                                            )}
                                          </TableCell>
                                          <TableCell>{total?.toFixed(2)}</TableCell>
                                          {/* <TableCell align='right'>
                                        <IconButton onClick={() => handleDeleteService(data.id)}>
                                          <Delete />
                                        </IconButton>
                                      </TableCell> */}
                                        </TableRow>
                                      </>
                                    );
                                  })}
                                  {additionalSelectedServices?.map((data, index) => {
                                    const quantityFieldName = `service_quantity_${index}`;
                                    const dataQuantity = data?.quantity ? data?.quantity : 1;
                                    const dataCost = data.unit_cost || data.total_cost

                                    const total = data.sellingPrice * dataQuantity
                                    const markup = dataCost / Number(total)
                                    data['markup'] = markup ? markup?.toFixed(2) : 0.00
                                    data['quantity'] = dataQuantity
                                    totalServiceMarkup += markup
                                    data['total'] = total ? total?.toFixed(2) : 0.00
                                    data['totalServiceMarkup'] = totalServiceMarkup?.toFixed(2)
                                    let originalMarkup = data.originalMarkup || 0
                                    originaltotalServiceMarkup += originalMarkup

                                    console.log('total---', total);
                                    console.log('data---', data);
                                    return (
                                      <>
                                        <TableRow key={data.id}>
                                          <TableCell>{data.name}</TableCell>

                                          <TableCell>
                                            <TextField
                                              type="number"
                                              // sx={{ width: 400 }}                                                                                
                                              label={'cost per hour'}
                                              disabled={!user.isVendor}
                                              value={Number(data?.sellingPrice) || 0}
                                              defaultValue={0}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                console.log('newValue-----', newValue);
                                                if (newValue.startsWith('-')) {
                                                  newValue = newValue.slice(1);
                                                }
                                                // data['quantity'] = newValue || 1;
                                                const newData = { ...data, sellingPrice: newValue || 0 };
                                                const updatedServices = [...additionalSelectedServices];
                                                updatedServices[index] = newData;
                                                setAdditionalSelectedServices(updatedServices);

                                              }}


                                            />
                                          </TableCell>
                                          <TableCell>
                                            <TextField
                                              type="number"
                                              // sx={{ width: 400 }}                                                                                
                                              label={'Hours'}
                                              disabled={!user.isVendor}
                                              {...getFieldProps(quantityFieldName)}
                                              value={Number(data?.quantity) || 1}
                                              defaultValue={1}
                                              onChange={(event) => {
                                                let newValue = event.target.value;
                                                console.log('newValue-----', newValue);
                                                if (newValue.startsWith('-')) {
                                                  newValue = newValue.slice(1);
                                                }

                                                // data['quantity'] = newValue || 1;
                                                const newData = { ...data, quantity: newValue || 1 };
                                                const updatedServices = [...additionalSelectedServices];
                                                updatedServices[index] = newData;
                                                setAdditionalSelectedServices(updatedServices);
                                                setFieldValue(quantityFieldName, newValue);
                                              }}

                                              error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                              helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                            />
                                          </TableCell>
                                          <TableCell>{total ? total?.toFixed(2) : 0.00}</TableCell>
                                          {!user.isVendor ? !vendorId && <TableCell align='right'>
                                            <IconButton onClick={() => handleDeleteService(data.id)}>
                                              <Delete />
                                            </IconButton>
                                          </TableCell> : ""}
                                        </TableRow>
                                      </>
                                    );
                                  })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          <Divider />
                          {/* <TextField
                            fullWidth
                            multiline
                            minRows={3}
                            maxRows={7}
                            label="Notes"
                            {...getFieldProps('notes')}
                            error={Boolean(touched.notes && errors.notes)}
                            helperText={touched.notes && errors.notes}
                          /> */}
                        </>}
                          <LabelStyleHead>Materials</LabelStyleHead>
                          <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }}>
                          <Autocomplete
                            sx={{ width: 400 }}
                            multiple
                            id="combo-box-demo"
                            // options={materials?.filter(material => 
                            //   !setSelectedMaterials.some(selectedMaterial => selectedMaterial.id === material.id)
                            // ) || []}
                            options={allMaterials}
                            value={selectedMaterials}
                            disabled={user.isVendor || vendorId}
                            onChange={(event, newValue) => {
                              if (newValue.some((option) =>
                                values.materials.some((product) => product.product_id === option.id)
                              )) {
                                return;
                              }
                              handleMaterial(newValue);
                              setFieldValue('materials', newValue);
                            }}
                            filterOptions={(options, { inputValue }) => {
                              return options.filter((option) => {
                                const searchText = inputValue.toLowerCase();
                                return (
                                  option.name?.toLowerCase().includes(searchText) ||
                                  option.description?.toLowerCase().includes(searchText)
                                );
                              });
                            }}
                            getOptionLabel={(option) => option.description || ''}
                            renderOption={(props, option) => (
                              <li {...props}>
                                {option.description}
                              </li>
                            )}
                            isOptionEqualToValue={(option, value) => option.id === value.id}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                label="Select  Materials"
                                error={Boolean(touched.materials && errors.materials)}
                                helperText={touched.materials && errors.materials}
                              />
                            )}
                          />
                          </Stack>
                          <LabelStyle>Selected Materials</LabelStyle>
                          <Scrollbar>
                            <TableContainer sx={{ minWidth: 500 }}>
                              <Table>
                                <TableHead>
                                  <TableRow>
                                    {MATERIAL_VALUE?.map((val) => (
                                      <TableCell key={val.id}>{val.value}</TableCell>
                                    ))}
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {selectedMaterials?.map((data, index) => {
                                  console.log("##################Data%%%%%%%%%",data);
                                  let id=data?.product_id || data?.id
                                  const quantityFieldName = `quantity_${id}`;
                                  const discountFieldName = `discount_${id}`;

                                  let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                                  unitName = unitName[0]?.name
                                  let shortUnitName = ''
                                  if (unitName == 'Square feet') {
                                    shortUnitName = 'Sq ft'
                                  } else if (unitName == 'Lineal feet') {
                                    shortUnitName = 'Lin ft'
                                  } else if (unitName == 'Square Inches') {
                                    shortUnitName = 'Sq Inches'
                                  } else if (unitName == 'Unit') {
                                    shortUnitName = 'Unit'
                                  }
                                  const dataQuantity = data?.quantity || 1
                                   const dataDiscount = data?.discount ? data.discount : 0
                                  const rowTotal = calculateTotal(data?.sellingPrice || 0, dataQuantity, dataDiscount, data?.quantity, data?.locationQuantity);

                                  return (
                                    <>
                                      <TableRow key={data?.id}>
                                        <TableCell>{data?.product_name || data?.name}</TableCell>
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            sx={{ width: 85 }}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '-') {
                                                event.preventDefault();
                                              }
                                            }}
                                            onWheel={(e)=>e.target.blur()}
                                            inputProps={{ min: 0 }}
                                            fullWidth
                                            label={"Unit Price"}
                                            // {...getFieldProps(quantityFieldName)}
                                            disabled={!user.isVendor}
                                            defaultValue={data?.sellingPrice ? data?.sellingPrice : 0}
                                            value={data?.sellingPrice ? data?.sellingPrice : 0}
                                            onChange={(event) => {

                                              let newValue = event.target.value;


                                              setSelectedMaterials(pv => ([...pv.map(p => {
                                                if (p.id === data.id) {

                                                  return {
                                                    ...p,
                                                    // quantity:newValue,
                                                    sellingPrice: newValue
                                                  }
                                                }
                                                else{
                                                  return p
                                                }
                                              })]));

                                            }}

                                          // error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                          // helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>

                                        <TableCell>
                                          <TextField
                                            type="number"
                                            sx={{ width: 85 }}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            disabled={(user.isVendor || vendorId || shortUnitName == 'Unit') ? true : false}
                                            label={shortUnitName}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data?.quantity ? data?.quantity : 1}
                                            value={data?.quantity ? data?.quantity : 1}

                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }

                                              setSelectedMaterials(pv => ([...pv.map(p => {
                                                if (p.id === data.id) {



                                                  return {
                                                    ...p,
                                                    quantity: newValue,

                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              console.log("###############SElected services", selectedServices);
                                              // setSelectedServices(pv => ([...pv.map(service => {
                                              //   if (service.product_id === data.id && service.prQty) {
                                              //     return {
                                              //       ...service,
                                              //       quantity: (service.prQty * (newValue) * (service?.locationQuantity || 1)).toFixed(2),
                                              //       qtyData: Number(newValue),
                                              //     };
                                              //   } else {
                                              //     return {
                                              //       ...service,

                                              //     }
                                              //   }
                                              // })]));


                                              data['quantity'] = newValue || 1;

                                              setFieldValue(quantityFieldName, newValue);
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          <TextField
                                            type="number"
                                            sx={{ width: 85 }}
                                            onKeyPress={(event) => {
                                              if (event.key === '0' && event.target.value === '') {
                                                event.preventDefault();
                                              }
                                              if (event.key === '.') {
                                                event.preventDefault();
                                              }
                                            }}
                                            fullWidth
                                            disabled={user.isVendor || vendorId}
                                            label={"Qty"}
                                            // {...getFieldProps(quantityFieldName)}
                                            defaultValue={data?.locationQuantity ? data?.locationQuantity : 1}
                                            value={data?.locationQuantity ? data?.locationQuantity : 1}

                                            onChange={(event) => {

                                              let newValue = event.target.value;
                                              if (newValue.startsWith('-')) {
                                                newValue = newValue.slice(1);
                                              }
                                              newValue = newValue.replace(/[^0-9]/g, '');
                                              if (newValue === '' || Number(newValue) <= 0) {
                                                newValue = 1;
                                              }
                                              else {
                                                newValue = Number(newValue);
                                              }

                                              setSelectedMaterials(pv => ([...pv.map(p => {
                                                if (p.id === data.id) {



                                                  return {
                                                    ...p,
                                                    locationQuantity: newValue,

                                                  }
                                                } else {
                                                  return p;
                                                }
                                              })]));
                                              console.log("###############SElected services", selectedServices);
                                              // setSelectedServices(pv => ([...pv.map(service => {
                                              //   if (service.product_id === data.id && service.prQty) {
                                              //     return {
                                              //       ...service,
                                              //       quantity: (service.prQty * (newValue) * (service?.locationQuantity || 1)).toFixed(2),
                                              //       qtyData: Number(newValue),
                                              //     };
                                              //   } else {
                                              //     return {
                                              //       ...service,

                                              //     }
                                              //   }
                                              // })]));


                                              data['quantity'] = newValue || 1;

                                              setFieldValue(quantityFieldName, newValue);
                                            }}

                                            error={Boolean(touched[quantityFieldName] && errors[quantityFieldName])}
                                            helperText={touched[quantityFieldName] && errors[quantityFieldName]}
                                          />
                                        </TableCell>
                                        <TableCell>
                                          {rowTotal.toFixed(2)}
                                        </TableCell>
                                        {!user.isVendor ? !vendorId && <TableCell >
                                          <IconButton onClick={() => handleDeleteMaterial(data?.id || data?.product_id)}>
                                            <Delete />
                                          </IconButton>
                                        </TableCell> : ""}
                                      </TableRow>
                                    </>
                                  );
                                })}
                                </TableBody>
                              </Table>
                            </TableContainer>
                          </Scrollbar>
                          <Divider />
                        {
                          (user.isVendor || vendorId) ?
                            <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent={'start'} alignItems={'center'}>
                              <Stack flexDirection={'column'}>
                                <TextField
                                  //   fullWidth
                                  sx={{ width: 400 }}
                                  label="Tariff"
                                  type="number"
                                  inputProps={{ min: 0 }}
                                  {...getFieldProps('tariff')}
                                  disabled={!user.isVendor}
                                // error={Boolean(touched.tariff && errors.tariff)}
                                // helperText={touched.tariff && errors.tariff}
                                />
                              </Stack>
                              <TextField
                                //   fullWidth
                                sx={{ width: 400 }}
                                label="Shipping Cost"
                                type="number"
                                inputProps={{ min: 0 }}
                                {...getFieldProps('shipping_cost')}
                                disabled={!user.isVendor}
                                error={Boolean(touched.shipping_cost && errors.shipping_cost)}
                                helperText={touched.shipping_cost && errors.shipping_cost}
                              />
                            </Stack>
                            :
                            ''
                        }
                        <Typography sx={{ color: theme.palette.error.main }}>**All values in the software are rounded to two decimal places in accordance with standard US calculation practices.</Typography>
                        <Stack direction={{ xs: 'column', sm: 'row' }} spacing={{ xs: 3, sm: 2 }} justifyContent={'space-between'}>
                          <Stack>
                            <Autocomplete
                              sx={{ width: 400 }}
                              // disabled={!((!vendorId && details.status === 2) && (userType === 3 ? (invoice?.proposalStatus === 1 || !invoice?.proposalStatus) : true))}
                              disabled={user.isVendor || vendorId}
                              id="combo-box-demo"
                              options={taxCategories || []}
                              value={selectedTaxCategory || null}
                              onChange={(event, newValue) => {
                                setSelectedTaxCategory(newValue);
                              }}
                              renderInput={(params) => (
                                <TextField {...params} label="Select tax category" />
                              )}
                              getOptionLabel={(option) => option.name ? option.name : ''}
                            />
                          </Stack>
                          <Stack>
                            <Box>
                            <Typography >
                              Sub Total: {totalsum ? totalsum.toFixed(2) : '0.00'}
                            </Typography>
                             <Box display="flex" alignItems="center" gap={1}>
                            <Typography >
                              Tax: {parseFloat(taxAmount).toFixed(2) || 0.00}
                            </Typography>

                              {
                                                            proposalData[0]?.avalara_code ? (
                                                          <>
                                                             <img
                                                               src={AVALARALOGO}
                                                               width="20px"
                                                               height="12px"
                                                               style={{ marginTop: '2px' }} // Adjust for alignment if needed
                                                               alt="Avalara logo"
                                                             />
                                                              <Typography sx={{ marginTop: '8px',color:"#fd6400",fontSize:"12px"}}>
                                                                            Synced with Avalara
                                                               </Typography>
                                                              </>
                            ):""}

                            </Box>
                            <Typography sx={{ color: 'yellow' }}>
                              Grand Total: {grandTotal || 0.00}
                            </Typography>
                            </Box>
                            {/* <Stack> */}
                            {
                              details.statusRfp==2 && details?.paymentMode?
                              <Typography sx={{ color: 'green' }}>Payment Mode : {details?.paymentMode?details?.paymentMode : ''}</Typography>
                              :
                              ''
                            }
                          {/* </Stack> */}

                            {/* <Typography sx={{ color: 'yellow' }}>Grand Total : {totalsum ? totalsum?.toFixed(2) : 0}</Typography> */}

                          </Stack>



                        </Stack>
                        {console.log("$$$$$$$$$$$$$$$$Proposal",invoice?.proposalStatus)}

                        <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                          {((!vendorId && details.status === 2)) &&
                             (userType === 3 ? (invoice?.proposalStatus === 1 || empty(invoice?.proposalStatus)) : true) &&
                            <LoadingButton
                              type="submit"
                              variant="contained"
                              loading={isSubmitting}
                            >
                              Save Order
                            </LoadingButton>
                          }

                          {/* <Button variant="outlined"  onClick={() =>{
                          setOpenPreview(!openPreview),
                          setValuesToPreview() }}>
                          Preview
                        </Button> */}
                          <Button variant="outlined" onClick={() =>  openEdit ? handleCancel(true) : handleCancel()}>
                            {vendorId ? "Back" : "Cancel"}
                          </Button>
                        </Box>
                      </Stack>
                    </Card>
                  </Grid>
                </Grid>
              </Form>
            </FormikProvider>
          )}
          {!openEdit && (
            <>
            {(details && invoice) ?
              <Stack direction={'row'} display={'flex'} alignItems={'center'} spacing={{ xs: 3, sm: 2 }}>
                {/* <Typography  fontSize={'1.09rem'} variant="overline" sx={{ color: 'text.secondary', }}>RFQ</Typography> */}
                {details?.id && invoice?.sub_total !== 0 && !user?.isVendor && (

                  <Link
                    color={theme.palette.success.dark}
                    onClick={() => setOpenInvoice(!openInvoice)}
                    // component={RouterLink}
                    to={''}
                  >
                    {details?.status === 2 ? (
                      <Badge badgeContent={'1'} color={'warning'}>
                        <Typography fontSize={'1.09rem'} variant="overline">
                          <span style={{ textDecoration: 'underline' }}>Invoice</span>
                        </Typography>
                      </Badge>) : (
                      <Typography fontSize={'1.09rem'} variant="overline">Invoice</Typography>
                    )}
                  </Link>

                )}
                {/* <Typography fontWeight={'0.09rem'} variant="overline" >
                  <Label
                    sx={{ p: '12px' }}
                    variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                    color={getStatusColorAndLabelProposal(details?.awarded?2:1).color} >
                    {getStatusColorAndLabelProposal(details?.status).label}
                  </Label>
                </Typography> */}
              </Stack> : ''}

              <Grid container spacing={3}>

                <Grid sx={{ mt: 3 }} item xs={12} md={12}>
                  <Stack spacing={3}>
                    <Stack spacing={5}>
                      <Tabs
                        value={currentTab}
                        scrollButtons="auto"
                        variant="scrollable"
                        allowScrollButtonsMobile
                        onChange={handleChangeTab}
                      >
                        {ACCOUNT_TABS.map((tab) => (
                          <Tab
                            disableRipple
                            key={tab.value}
                            label={capitalCase(tab.value)}
                            value={tab.value}
                          />
                        ))}
                      </Tabs>

                      {ACCOUNT_TABS.map((tab) => {
                        const isMatched = tab.value === currentTab
                        return isMatched && <Box key={tab.value}>{tab.component}</Box>
                      })}
                    </Stack>
                  </Stack>
                </Grid>

              </Grid>
            </>)}

          {/* adding client modal  */}
          <AddClients
            request_id={id}
            setIsOpen={setIsOpen}
            setAllClients={setAllClients}
            allClients={allClients?.filter(a => !a.isVendor)}
            addClient={addClient}
            setAddClient={setAddClient} />
          <AddClients
            isVendor
            request_id={id}
            setIsOpen={setIsOpen}
            setAllClients={setAllClients}
            allClients={allClients?.filter(a => a.isVendor)}
            addClient={addVendor}
            setAddClient={setAddVendor} />
          <AddProposal
            request_id={id}
            setIsOpen={setIsOpen}
            setReloadData={() => setRefresh(!refresh)}
            addProposal={addProposal}
            setAddProposal={setAddProposal} />
          {/* invoice modal */}
          <Modal modalTitle={'Sales Order Details'} open={openInvoice === true} handleClose={() => setOpenInvoice(false)}>
            <Stack direction={{ xs: 'column', sm: 'row', md: 'column' }}
              spacing={{ xs: 3, sm: 2 }}>
              <Stack direction="row" justifyContent={'flex-end'} alignItems="center" spacing={1}>
                <ReactToPrint
                  trigger={() => (<Button> <Print />Print</Button>)}
                  content={() => componentRef.current}
                  copyStyles={false}
                  pageStyle={`
      @media print {
        body {
          font-size: 12pt;
        }
        table {
          width: 100%;
          border-collapse: collapse;
          margin-bottom: 10px;
        }

        th, td {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: left;
        }
        #right {
          text-align: right;
          margin-top: -200px; 
        }
        #total {
          text-align: right;
          display:flex;
          justify-content: flex-end;
        }
        #subtotal {
          text-align: left;
          
        }
        #discount {
          text-align: left;
          word-wrap: break-word;
          margin-right: 100px;
      }
      
        #totalmain {
          text-align: left;
          
        }
        #subtotal1 {
          text-align: left;
          
        }
        #discount1 {
          text-align: left;
          word-wrap: break-word;
          margin-right: 30px;
      }
      
        #totalmain1 {
          text-align: left;
          
        }
        #total1 {
          text-align: right;
          display:flex;
          justify-content: flex-end;
          margin-top: -220px; 
          
        }
        #order{
          margin-bottom:-20px
        }
        #title{
          margin-bottom:-20px
        }
        #orderID {
          margin-bottom:-20px
        }
        #to {
          margin-bottom:-20px
        }
        
      }
    `}

                />
                {SEND_EMAIL && 
                <Button onClick={handleSendEmail}>Send Email</Button>
                }
                <div style={{ display: "none" }}>
                  <PrintFunction
                    invoiceDate={invoiceDate}
                    openInvoice={openInvoice}
                    details={details}
                    invoice={invoice}
                    subTotal={subTotal}
                    ref={componentRef}
                    additionalSelectedServices={additionalSelectedServices}
                    data={data}
                  />
                </div>

              </Stack>
            </Stack>
            <Grid container spacing={3} >

              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                <Grid item xs={12} sm={6} sx={{ mb: 5 }}>
                  <Box component="img" alt="logo" src={COMPANY_LOGO} sx={{ height: 98 }} />
                </Grid>
                <Typography variant="body2">{COMPANY_NAME}</Typography>
                <Typography variant="body2">www.{COMPANY_NAME}.com</Typography>
                <Typography variant="body2">
                  {data?.address}, {data?.city}, {data?.state}, {data?.zipcode}
                </Typography>
                <Typography variant="body2">Telephone: +15208362947</Typography>

              </Grid>
              <Grid item xs={12} sm={6} sx={{ mb: 5 }}>

                <Typography variant="body2">
                  Order date: {invoiceDate}
                </Typography>
                {/* <Stack sx={{display:'flex',flexDirection:'row'}}> */}
                {/* <Typography variant="body2">Order status:</Typography> */}
                <Label
                  variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                  color={getStatusColorAndLabel(details?.status).color} >
                  {getStatusColorAndLabel(details?.status).label}
                </Label>
                {/* </Stack> */}
                <Typography variant="body2">Request Name:{details?.name}</Typography>
                <Typography variant="body2">Order ID: #{details?.doc_number}</Typography>
                <Typography paragraph variant="overline" sx={{ color: 'text.disabled', marginTop: '20px' }}>
                  TO {invoice?.customer_name}
                </Typography>
                <Typography variant="body2">Phone: {invoice?.customer_phone}</Typography>
              </Grid>
            </Grid>
            <Grid container spacing={2}>

              <Scrollbar>
                <Typography variant='h6'>Products</Typography>
                <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell>PRODUCT</TableCell>
                        <TableCell>UNIT PRICE</TableCell>
                        <TableCell align="center">UNIT</TableCell>
                        <TableCell>QTY</TableCell>
                        <TableCell>DISCOUNT</TableCell>
                        <TableCell>SUB TOTAL</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {invoice?.cust_product?.map((val) => {
                        const { vid, product_name, product_price, product_retail_price,
                          quantity, locationQuantity, product_total, discount, unit, unit_qty
                        } = val
                        let unitName = UNITS?.filter((item) => item?.id == unit)
                        unitName = unitName[0]?.name
                        let shortUnitName = ''
                        if (unitName == 'Square feet') {
                          shortUnitName = unit_qty ? 'Sq ft (' + unit_qty + ')' : 'Sq ft'
                        } else if (unitName == 'Lineal feet') {
                          shortUnitName = unit_qty ? 'Lin ft (' + unit_qty + ')' : 'Lin ft'
                        } else if (unitName == 'Square Inches') {
                          shortUnitName = unit_qty ? 'Sq Inches (' + unit_qty + ')' : 'Sq Inches'
                        } else if (unitName == 'Unit') {
                          shortUnitName = 'Unit'
                        }
                        //  subTotal += product_total                   
                        return (

                          <TableRow key={vid} sx={{
                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                          }}>
                            <TableCell>{product_name}</TableCell>
                            <TableCell>{product_retail_price ? product_retail_price?.toFixed(2) : 0.00}</TableCell>
                            <TableCell align="center">{quantity}({shortUnitName})</TableCell>
                            <TableCell>{locationQuantity}</TableCell>
                            <TableCell>{discount ? discount?.toFixed(2) : 0.00}</TableCell>
                            <TableCell>{product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                          </TableRow>
                        )
                      }
                      )}

                      {/* <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="overline">Subtotal</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="overline">{subTotal ? subTotal?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="overline">Additional Labor Cost</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="overline">{details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography>
                      </TableCell>
                    </RowResultStyle>
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="overline">Extra Discount</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="overline">{invoice?.extra_discount ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                      </TableCell>

                    </RowResultStyle>
                    <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="subtitle1">Total</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="subtitle1">{invoice?.total ? invoice?.total?.toFixed(2) : 0.00}</Typography>
                      </TableCell>

                    </RowResultStyle> */}

                    </TableBody>
                  </Table>
                </TableContainer>

                <Typography variant='h6' sx={{ mt: 2 }}>{(additionalSelectedServices?.length > 0) ? "Additional Services" : ""}</Typography>
                <TableContainer sx={{ minWidth: 420, mt: 3 }}>
                  <Table>
                    {(additionalSelectedServices?.length > 0) &&
                      <TableHead>
                        <TableRow>
                          <TableCell colSpan={2}>NAME</TableCell>
                          <TableCell>UNIT COST</TableCell>
                          <TableCell>HOURS</TableCell>
                          <TableCell>TOTAL COST</TableCell>
                        </TableRow>
                      </TableHead>}
                    <TableBody>
                      {invoice?.cust_product?.map((val) => {
                        const { vid, product_name, product_price, product_retail_price,
                          quantity, product_total, discount, unit, unit_qty
                        } = val
                        let unitName = UNITS?.filter((item) => item?.id == unit)
                        unitName = unitName[0]?.name
                        let shortUnitName = ''
                        if (unitName == 'Square feet') {
                          shortUnitName = unit_qty ? 'Sq ft (' + unit_qty + ')' : 'Sq ft'
                        } else if (unitName == 'Lineal feet') {
                          shortUnitName = unit_qty ? 'Lin ft (' + unit_qty + ')' : 'Lin ft'
                        } else if (unitName == 'Square Inches') {
                          shortUnitName = unit_qty ? 'Sq Inches (' + unit_qty + ')' : 'Sq Inches'
                        } else if (unitName == 'Unit') {
                          shortUnitName = 'Unit'
                        }
                        subTotal += product_total
                        return (
                          null
                        )
                      })}

                      {openInvoice && additionalSelectedServices?.map((ser) => {
                        console.log('additionalSelectedServices--', ser);
                        return (
                          <TableRow sx={{
                            borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                          }}>
                            <TableCell colSpan={2}>{ser?.name}</TableCell>
                            <TableCell>{ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                            <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                            <TableCell>{ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                          </TableRow>
                        )
                      }
                      )}

                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="overline">Subtotal</Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="overline">{subTotal ? subTotal?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>

                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="overline">ADDITIONAL SERVICES</Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="overline">{details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>

                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="overline">Extra Discount</Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="overline">{invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>

                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="overline">Tax</Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="overline">{invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
                        </TableCell>
                      </RowResultStyle>

                      <RowResultStyle>
                        <TableCell colSpan={3} />
                        <TableCell align="center">
                          <Typography variant="subtitle1">Total</Typography>
                        </TableCell>
                        <TableCell align="center" width={10}>
                          <Typography variant="subtitle1">{invoice?.total ? invoice?.total?.toFixed(2) : 0.00}</Typography>
                        </TableCell>

                      </RowResultStyle>

                    </TableBody>
                  </Table>
                </TableContainer>
                {(userType == 3 && details?.status != 4) &&
                  <Box sx={{ mt: 3, display: 'flex', justifyContent: 'flex-end', gap: 1 }}>
                    <Button type="submit" variant="contained"
                      onClick={() => setConfirmInvoice(true)}
                    // onClick={()=>handleAcceptorRejectInvoice(1)}
                    >
                      Accept
                    </Button>
                    <Button size="small" variant="outlined"
                      onClick={() => setRejectInvoice(true)}
                      //  onClick={()=>handleAcceptorRejectInvoice(2)}
                      sx={{ color: theme.palette.error.main }} >
                      Reject
                    </Button>
                  </Box>}
                {/* {(userType ==3&&details?.status!=4&&details?.onboard_complete==0) && 
                <Box sx={{ mt: 3,  display: 'flex', justifyContent: 'flex-end',gap:1 }}>
                  <Button type="submit" variant="contained" 
                   onClick={()=> navigate(PATH_DASHBOARD.official.process,{state:{requestId:id}})}
                  // onClick={()=>handleAcceptorRejectInvoice(1)}
                   >                 
                   Proceed to Workflow
                  </Button>
                 
                </Box>} */}
              </Scrollbar>

            </Grid>
          </Modal>
          {/* delete popup */}
          <ConfirmationPopup
            open={openDelete}
            handleClick={handleDeleteRFQ}
            handleClose={() => { setOpenDelete(!openDelete), setIsOpen(false) }}
            message={'You want to delete this proposal '}
          />

          {/* Accept request invoice */}
          <ConfirmationPopup
            open={confirmInvoice}
            handleClick={() => handleAcceptorRejectInvoice(1)}
            handleClose={() => setConfirmInvoice(false)}
            message={'You want to accept this invoice '}
          />
          {/* reject request invoice */}
          {/* <ConfirmationPopup 
        open={invoiceReject}
        handleClick={()=>handleAcceptorRejectInvoice(2)}
         handleClose={()=>setRejectInvoice(false)}
         message={'You want to reject this invoice '}
        /> */}
          {/* Reopen rejected request  */}
          <ConfirmationPopup
            open={reOpen}
            handleClick={() => handleReopeningRequest()}
            handleClose={() => setReopen(false)}
            message={'You want to reopen this request '}
          />
          {/* Preview Modal */}
          {openPreview && (
            <Modal
              open={openPreview}
              handleClose={() => {
                setOpenPreview(false);
              }}
              modalTitle={'Preview'}
            >

              <Grid container sx={{ justifyContent: 'center' }} spacing={3}>
                <Grid item xs={12} md={12}>
                  <Stack
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'space-between',
                    }}
                    spacing={2}
                  >
                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>Name: </span>
                        {previewData?.name}
                      </Typography>

                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>Use custom welcome message: </span>
                        {previewData.welcome_message == null ? 'No' : previewData.welcome_message == false ? 'No' : 'Yes'}
                      </Typography>
                    </Stack>
                    <Stack>
                      <Typography variant="subtitle2" style={{ color: theme.palette.primary.darker }}>
                        Description:
                      </Typography>
                      <Typography variant="subtitle2" style={{ overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-word' }}>
                        {previewData?.description}
                      </Typography>
                    </Stack>
                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker,
                        overflowWrap: 'break-word', wordWrap: 'break-word',
                         wordBreak: 'break-word' }}>Skills or services required:</span> <br/>
                          <List>
                           {previewData?.skills?.map((val, index) => (
                           <ListItem sx={{ listStyleType: 'disc', paddingLeft: '20px' }} key={index}>
                           <ListItemText primary={val.name} />
                           </ListItem>
                                   ))}
                                </List>
                    </Typography> */}
                      {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Workflows: </span> <br/>                                           
                      <List>
                           {previewData?.workflow?.map((val, index) => (
                           <ListItem sx={{ listStyleType: 'dics', paddingLeft: '20px' }} key={index}>
                           <ListItemText primary={val.name} />
                           </ListItem>
                                   ))}
                                </List>
                    </Typography> */}
                    </Stack>
                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>Job Class: </span>
                        {previewData?.project_type?.name}
                      </Typography>
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker, }}>Job Types: </span>
                        {previewData?.project_category?.name}
                      </Typography>
                    </Stack>

                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>Project: </span>
                        {previewData?.community?.name}
                      </Typography>
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker, }}>Markup Type: </span>
                        {previewData?.markup_type?.name}
                      </Typography>
                    </Stack>

                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>Start Date: </span>
                        {moment.unix(previewData.start).format("MM/DD/YYYY")}
                      </Typography>
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>installation Date: </span>
                        {moment.unix(previewData.end).format("MM/DD/YYYY")}
                      </Typography>
                    </Stack>
                    <LabelStyle>Products</LabelStyle>
                    <Scrollbar>
                      <TableContainer sx={{ minWidth: 500 }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              {VALUEPreview?.map((val) => (
                                <TableCell>{val.value}</TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {selectedProducts?.map((data, index) => {
                              const quantityFieldName = `quantity_${data.product_id || data.id}`;
                              const discountFieldName = `discount_${data.product_id || data.id}`;
                              let unitName = UNITS?.filter((item) => item?.id == data?.unit);
                              let newShortUnitName = unitName?.[0]?.short_name || "";
                              let fullUnitName = unitName?.[0]?.name || "";
                              let shortUnitName = newShortUnitName;
                              // let unitName = UNITS?.filter((item) => item?.id == data?.unit)
                              // unitName = unitName[0]?.name
                              // let shortUnitName = ''
                              // if (unitName == 'Square feet') {
                              //   shortUnitName = data?.unit_qty ? 'Sq ft (' + data?.unit_qty + ')' : 'Sq ft'
                              // } else if (unitName == 'Lineal feet') {
                              //   shortUnitName = data?.unit_qty ? 'Lin ft (' + data?.unit_qty + ')' : 'Lin ft'
                              // } else if (unitName == 'Square Inches') {
                              //   shortUnitName = data?.unit_qty ? 'Sq Inches (' + data?.unit_qty + ')' : 'Sq Inches'
                              // } else if (unitName == 'Unit') {
                              //   shortUnitName = 'Unit'
                              // }
                              const dataPrice = data.product_price || data.price
                              const dataWholesalePrice = data.product_price || data.price
                              const dataQuantity = values[quantityFieldName]
                              const dataDiscount = data.discount ? data.discount : values[discountFieldName]
                              const dataretailPrice = data.product_retail_price || data.retail_price
                              // const markup = ((dataretailPrice - dataPrice) / dataPrice) * 100;
                              const rowTotal = calculateTotal(markupType == 1 ? dataPrice : (markupType == 2 ? dataretailPrice : 0), dataQuantity, dataDiscount, data.quantity, data.locationQuantity);
                              const invoiceAmount = data?.expected_material_cost + data?.expected_total_service_cost
                              let markup = markupType ? (invoiceAmount / rowTotal) : null
                              markup = markup ? Number(markup) : 0
                              // data['markup'] = Math.round(markup)
                              console.log("###########Discount", data);
                              return (
                                <TableRow key={data.id}>
                                  <TableCell>{data.product_name || data.name}</TableCell>
                                  {/* <TableCell>{invoiceAmount}</TableCell> */}
                                  <TableCell>{(hasMarkupPermission && markupType == 2) ? dataretailPrice : null}</TableCell>
                                  <TableCell>{(hasMarkupPermission && markupType == 1) ? dataPrice : null}</TableCell>
                                  <TableCell>
                                    {/* {hasMarkupPermission ? (data.markup ? data.markup?.toFixed(2) : 0) : null} */}
                                    {(hasMarkupPermission && markupType == 1) ? data.wholesaleMarkup
                                      : (hasMarkupPermission && markupType == 2) ? data.retailMarkup
                                        : null}
                                  </TableCell>
                                  {/* <TableCell>{shortUnitName}</TableCell> */}
                                  <TableCell>
                                    <TextField required
                                      fullWidth
                                      type='number'
                                      sx={{ width: 85 }}
                                      disabled
                                      label={shortUnitName}
                                      value={Number(data.quantity)}
                                      defaultValue={1}
                                    />
                                  </TableCell>

                                  {/* <TableCell>{data.id}</TableCell> */}
                                  <TableCell>
                                    <TextField
                                      disabled
                                      type="number"
                                      label="Discount"
                                      defaultValue={0}
                                      value={Number(data.discount)?.toFixed(2)}
                                    // {...getFieldProps(discountFieldName)}
                                    />
                                  </TableCell>
                                  <TableCell>
                                    {rowTotal?.toFixed(2)}
                                  </TableCell>
                                </TableRow>
                              );
                            })}

                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Scrollbar>
                    <LabelStyle>Services</LabelStyle>
                    <Scrollbar>
                      <TableContainer sx={{ minWidth: 500 }}>
                        <Table>
                          <TableHead>
                            <TableRow>
                              {VALUE_SERVICES?.map((val) => (
                                <TableCell>{val.value}</TableCell>
                              ))}
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {selectedServices?.map((data, index) => {
                              const dataCost = data.unit_cost || data.total_cost
                              let originalMarkup = data.originalMarkup || 0
                              let markup = data.markup || 0
                              const total = dataCost * data.quantity
                              data['total'] = total?.toFixed(2)
                              console.log("###########data total", data);
                              return (
                                <>
                                  <TableRow key={data.id}>
                                    <TableCell>{data.name}</TableCell>
                                    <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                    <TableCell>{data.cost}</TableCell>
                                    <TableCell>{dataCost}</TableCell>
                                    <TableCell>{data.quantity}</TableCell>
                                    <TableCell>{data.total}</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell align='right'>
                                    </TableCell>
                                  </TableRow>
                                </>
                              );
                            })}
                            {additionalSelectedServices?.map((data, index) => {
                              const dataCost = data.unit_cost || data.total_cost
                              const total = dataCost * (data?.quantity || 1)
                              data['total'] = total ? total?.toFixed(2) : 0.00
                              let originalMarkup = data.originalMarkup || 0
                              console.log("###########data total", data);
                              return (
                                <TableRow key={data.id}>
                                  <TableCell>{data.name}</TableCell>
                                  <TableCell>{originalMarkup?.toFixed(2)}</TableCell>
                                  <TableCell>{data.cost}</TableCell>
                                  <TableCell>{data.unit_cost || data.total_cost}</TableCell>
                                  <TableCell>{data?.quantity || 1}</TableCell>
                                  <TableCell>{data.total}</TableCell>
                                </TableRow>
                              );
                            })}
                          </TableBody>
                        </Table>
                      </TableContainer>
                    </Scrollbar>
                    <Divider />
                    <Stack>
                      <Typography variant="subtitle2" style={{ color: theme.palette.primary.darker }}>
                        Notes:
                      </Typography>
                      <Typography variant="subtitle2" sx={{ overflowWrap: 'break-word', wordWrap: 'break-word', wordBreak: 'break-word',color:'error.main' }}>
                        <Scrollbar
                          sx={{
                            maxHeight: 200,
                            '& .simplebar-content': {
                              maxHeight: 200,
                              display: 'flex',
                              flexDirection: 'column',
                            },
                          }}
                        >{previewData?.notes}</Scrollbar>

                      </Typography>
                    </Stack>
                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>Total Price: </span>
                        {totalsum < 0 ? 0 : totalsum?.toFixed(2)}
                      </Typography>

                      <Tooltip title="Total Selling Price - Total Product Formula Cost">
                        <Typography variant="subtitle2" sx={{ cursor: 'pointer' }}>
                          <span style={{ color: theme.palette.primary.darker }}>Total Markup Amount: </span>
                          {totalMarkupAmount ? totalMarkupAmount?.toFixed(2) : 0}
                        </Typography>
                      </Tooltip>

                      <Tooltip title="(Total Markup Amount / Total Product Formula Cost) * 100">
                        <Typography variant="subtitle2" sx={{ cursor: 'pointer' }}>
                          <span style={{ color: theme.palette.primary.darker }}>Total Markup Percentage: </span>
                          {totalMarkupPercentage ? totalMarkupPercentage?.toFixed(2) : 0}
                          {/* {totalMarkup ? totalMarkup?.toFixed(2) : 0} */}
                        </Typography>
                      </Tooltip>

                      {/* <Typography variant="subtitle2">
                      <span style={{ color:theme.palette.primary.darker }}>Total Service Markup: </span>
                      {totalServiceMarkup ? totalServiceMarkup?.toFixed(2) : 0}
                    </Typography> */}
                      <Typography variant="subtitle2">
                        <span style={{ color: theme.palette.primary.darker }}>Total Discount: </span>
                        {DiscountTotal ? DiscountTotal?.toFixed(2) : 0.00}
                      </Typography>
                    </Stack>
                    <Stack
                      direction={{ xs: 'column', md: 'row' }}
                      display="flex"
                      justifyContent="space-between"
                    >
                      <Typography variant="subtitle2">
                        <Label
                          variant={theme.palette.mode === 'light' ? 'ghost' : 'filled'}
                          color={getStatusColorAndLabel(status).color} >
                          {getStatusColorAndLabel(status).label}
                        </Label>
                      </Typography>
                    </Stack>

                  </Stack>
                </Grid>
              </Grid>
            </Modal>
          )}
          {/* reject request invoice */}
          {invoiceReject == true && <Dialog
            open={invoiceReject}
            onClose={() => { setRejectInvoice(false) }}
            aria-labelledby="alert-dialog-title"
            aria-describedby="alert-dialog-description"
            BackdropComponent={Backdrop}
            BackdropProps={{ invisible: true }}
          >
            <DialogTitle id="alert-dialog-title">
              {"Are you sure ?"}
            </DialogTitle>
            <DialogContent>
              <DialogContentText id="alert-dialog-description">
                You want to reject this invoice
              </DialogContentText>
              <TextField
                sx={{ width: 400 }}
                label="Reason For Rejection"
                type="text"
                multiline
                minRows={3}
                maxRows={7}
                onInput={(event) => setReason(event.target.value)}
              />
            </DialogContent>
            <DialogActions>
              <Button size="small" variant="contained"
                onClick={() => handleAcceptorRejectInvoice(2)}
                sx={{ color: theme.palette.background.paper }}>OK</Button>

              <Button size="small" variant="outlined"
                onClick={() => { setRejectInvoice(false), setReason('') }}
                sx={{ color: theme.palette.error.main }}
              >
                Cancel
              </Button>
            </DialogActions>
          </Dialog>}
          {/* reject request invoice */}

        </Container>}
          <DialogAnimate open={openPDFModal} onClose={() => setOpenPDFModal(false)}>
          <Card className={classes.dialogContent}>
            <div style={{width:'90%', display:'flex',justifyContent:'flex-end', marginBottom: '15px',marginLeft:'25px' }}>
                <Button
                  variant="outlined"
                  color="primary"
                  onClick={() => window.open(selectedPDF, '_blank')}
                  disabled={!selectedPDF}
                  startIcon={<Icon icon={filePdfIcon} width={20} height={20} />}
                  sx={{
                    fontSize:'14px'
                  }}
                >
                  View PDF
                </Button>
            </div>
            {pdfLoading && (
              <Skeleton variant="rectangular" width="100%" height={500} />
            )}
            <iframe
              src={selectedPDF}
              title="Selected PDF"
              width="100%"
              height="500px"
              frameBorder="0"
              style={{ display: pdfLoading ? 'none' : 'block' }}
              onLoad={() => setPdfLoading(false)}
            />
          </Card>
        </DialogAnimate>
    </Page>
  )
}

const PrintFunction = forwardRef(({ invoiceDate, details, additionalSelectedServices, invoice, subTotal, openInvoice, data }, ref) => {
  const theme = useTheme();
  const { COMPANY_LOGO, COMPANY_NAME } = useCompanyProfile()
  return (
    <Stack ref={ref}>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6} sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-start' }}>
          <Box component="img" alt="logo" src={COMPANY_LOGO} sx={{ height: 98, alignSelf: 'flex-start' }} />
        </Grid>
        <Grid item xs={12} sm={6} sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          {/* <Typography variant="h1">Invoice from:</Typography> */}
          <Typography variant="h2">{COMPANY_NAME}</Typography>
          <Typography variant="h2">www.{COMPANY_NAME}.com</Typography>
          <Typography variant="h3">
            {data?.address}<br /> {data?.city}<br /> {data?.state}, {data?.zipcode}
          </Typography>
          <Typography variant="h3">Telephone: +15208362947</Typography>
        </Grid>
      </Grid>

      <Grid container spacing={2}>
        {/* <Grid id="right" item xs={12} sm={6} >
        <Box sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
          <Typography variant="h3">Order date: {invoiceDate}</Typography>
          
          <Typography variant="h3">Title: {details?.name}</Typography>
          <Typography variant="h3">Order ID: {details?.id}</Typography>
          <Typography variant="h3" sx={{ marginTop: '20px' }}>To: {invoice?.customer_name}</Typography>
          <Typography variant="h3">Phone: {invoice?.customer_phone}</Typography>
          </Box>
        </Grid> */}

        <Grid id="total1" item xs={12} sm={6} >
          <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Box id="order" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount1" variant="h3" style={{ textAlign: 'left' }}>Order date:</Typography>
              <Typography variant="h3">{invoiceDate}</Typography>
            </Box>
            <Box id="title" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount1" variant="h3" style={{ textAlign: 'left' }}>Title:</Typography>
              <Typography variant="h3">{details?.name}</Typography>
            </Box>
            <Box id="orderID" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount" variant="h3" style={{ textAlign: 'left' }}>Order ID:</Typography>
              <Typography variant="h3">#{details?.doc_number}</Typography>
            </Box>
            <Box id="to" style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="totalmain1" variant="h3" >To:</Typography>
              <Typography variant="h3" style={{ textAlign: 'right' }}>{invoice?.customer_name}</Typography>
            </Box>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="totalmain1" variant="h3" >Phone:</Typography>
              <Typography variant="h3" style={{ textAlign: 'right' }}>{invoice?.customer_phone}</Typography>
            </Box>

          </Box>
        </Grid>

        <Scrollbar>
          <TableContainer sx={{ minWidth: 420 }}>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>PRODUCT</TableCell>
                  <TableCell>UNIT PRICE</TableCell>
                  <TableCell>UNIT</TableCell>
                  <TableCell>QTY</TableCell>
                  <TableCell>DISCOUNT</TableCell>
                  <TableCell>SUB TOTAL</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {invoice?.cust_product?.map((val) => {
                  const { vid, product_name, unit_qty, product_price, product_retail_price, quantity, product_total, discount, unit } = val;
                  subTotal += product_total;
                  let unitName = UNITS?.filter((item) => item?.id == unit)
                  unitName = unitName[0]?.name
                  let shortUnitName = ''
                  if (unitName == 'Square feet') {
                    shortUnitName = unit_qty ? 'Sq ft (' + unit_qty + ')' : 'Sq ft'
                  } else if (unitName == 'Lineal feet') {
                    shortUnitName = unit_qty ? 'Lin ft (' + unit_qty + ')' : 'Lin ft'
                  } else if (unitName == 'Square Inches') {
                    shortUnitName = unit_qty ? 'Sq Inches (' + unit_qty + ')' : 'Sq Inches'
                  } else if (unitName == 'Unit') {
                    shortUnitName = 'Unit'
                  }
                  return (
                    <TableRow key={vid} sx={{
                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`,
                      '& .productName': {
                        fontWeight: 'bold',
                      },
                    }}>
                      <TableCell variant="h4" className="productName">{product_name}</TableCell>
                      <TableCell variant="h4">{product_retail_price ? product_retail_price?.toFixed(2) : 0.00}</TableCell>
                      <TableCell variant="h4">{shortUnitName}</TableCell>
                      <TableCell variant="h4">{quantity}</TableCell>
                      <TableCell variant="h4">{discount ? discount?.toFixed(2) : 0.00}</TableCell>
                      <TableCell variant="h4">{product_total ? product_total?.toFixed(2) : 0.00}</TableCell>
                    </TableRow>
                  )
                }
                )}

                {/* <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="h3">Subtotal</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="h3">{subTotal}</Typography>
                      </TableCell>

                    </RowResultStyle> */}
                {/* <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="h3">Extra Discount</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="h3">{invoice?.extra_discount}</Typography>
                      </TableCell>

                    </RowResultStyle> */}

                {/* <RowResultStyle>
                      <TableCell colSpan={3} />
                      <TableCell align="center">
                        <Typography variant="h3">Total</Typography>
                      </TableCell>
                      <TableCell align="center" width={10}>
                        <Typography variant="h3">{invoice?.total}</Typography>
                      </TableCell>

                    </RowResultStyle> */}

              </TableBody>
            </Table>
          </TableContainer>

          {(additionalSelectedServices?.length > 0) && <Typography variant='h4' sx={{ mt: 2 }}>Additional Services</Typography>}
          <TableContainer sx={{ minWidth: 420, mt: 3 }}>
            <Table>
              {(additionalSelectedServices?.length > 0) &&
                <TableHead>
                  <TableRow>
                    <TableCell>NAME</TableCell>
                    <TableCell>UNIT COST</TableCell>
                    <TableCell>HOURS</TableCell>
                    <TableCell>TOTAL COST</TableCell>
                  </TableRow>
                </TableHead>}
              <TableBody>
                {openInvoice && additionalSelectedServices?.map((ser) => {
                  console.log('additionalSelectedServices--', ser);
                  return (
                    <TableRow sx={{
                      borderBottom: (theme) => `solid 1px ${theme.palette.divider}`
                    }}>
                      <TableCell>{ser?.name}</TableCell>
                      <TableCell>{ser ? ser?.unit_cost?.toFixed(2) : 0}</TableCell>
                      <TableCell>{ser ? ser?.quantity?.toFixed(2) : 0}</TableCell>
                      <TableCell>{ser ? ser?.total_cost?.toFixed(2) : 0}</TableCell>
                    </TableRow>
                  )
                }
                )}

              </TableBody>
            </Table>
          </TableContainer>
        </Scrollbar>

        <Grid id="total" item xs={12} sm={6} >
          <Box sx={{ mb: 5, display: 'flex', flexDirection: 'column', alignItems: 'flex-end' }}>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="subtotal" variant="h2" >Subtotal</Typography>
              <Typography variant="h2" style={{ textAlign: 'right' }}>{subTotal ? subTotal?.toFixed(2) : 0.00}</Typography>
            </Box>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount" variant="h2" style={{ textAlign: 'left' }}> ADDITIONAL SERVICES</Typography>
              <Typography variant="h2">{details ? details?.labour_cost?.toFixed(2) : 0.00}</Typography>
            </Box>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount" variant="h2" style={{ textAlign: 'left' }}>Extra Discount</Typography>
              <Typography variant="h2">{invoice ? invoice?.extra_discount?.toFixed(2) : 0.00}</Typography>
            </Box>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="discount" variant="h2" style={{ textAlign: 'left' }}>Tax</Typography>
              <Typography variant="h2">{invoice ? invoice?.tax_amount?.toFixed(2) : 0.00}</Typography>
            </Box>
            <Box style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              <Typography id="totalmain" variant="h2" >Total</Typography>
              <Typography variant="h2" style={{ textAlign: 'right' }}>{invoice?.total ? invoice?.total?.toFixed(2) : 0.00}</Typography>
            </Box>

          </Box>
        </Grid>

      </Grid>
    </Stack>
  )
})